<template>
  <div class="mainContainer" v-loading="importLoading">
    <div class="tabs">
      <div @click="typeFun(0)" class="left" :class="{ active: planType === 0 }">运输计划</div>
      <div @click="typeFun(1)" class="right" :class="{ active: planType === 1 }">委托车</div>
    </div>
    <div v-if="planType == 0" class="nav">
      <div class="navContainer" style="width: 230px">
        <p>委托商：</p>
        <el-input v-model="transport.consignorName" size="mini" style="width: 150px" placeholder="请输入委托商" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>批次号：</p>
        <el-input v-model="transport.batchNumber" size="mini" style="width: 150px" placeholder="请输入批次号" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>计划类型：</p>
        <el-input v-model="transport.planType" size="mini" style="width: 150px" placeholder="请输入计划类型" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>运输方式：</p>
        <el-select v-model="transport.transportMode" filterable size="mini" style="width: 150px" placeholder="请选择状态">
          <el-option label="全部" value="" />
          <el-option label="公路" value="1" />
          <el-option label="水路" value="2" />
          <el-option label="水陆联运" value="3" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>回单类型：</p>
        <el-select v-model="transport.receiptType" filterable size="mini" style="width: 150px" placeholder="请选择状态">
          <el-option label="全部" value="" />
          <el-option label="电子回单" value="1" />
          <el-option label="纸质回单" value="2" />
          <el-option label="无" value="3" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>锁定状态：</p>
        <el-select v-model="transport.switchState" filterable size="mini" style="width: 150px" placeholder="请选择状态">
          <el-option label="全部" value="" />
          <el-option label="未锁定" value="0" />
          <el-option label="已锁定" value="1" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 400px">
        <p>创建时间：</p>
        <el-date-picker v-model="entrust.startTimeIpt" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="开始日期" />
        <span style="display: inline-block; width: 15px; text-align: center; font-size: 18px">-</span>
        <el-date-picker v-model="entrust.endTimeIpt" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="结束日期" />
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="addBtn">新增</el-button>
      </div>
    </div>
    <div v-if="planType == 1" class="nav">
      <div class="navContainer" style="width: 230px">
        <p>批次号：</p>
        <el-input
          v-model="entrust.batchIpt"
          size="mini"
          style="width: 150px"
          placeholder="请输入批次号"
          @paste.native.capture.prevent="
            value => {
              return searchCopyFormat(value, 'batchIpt');
            }
          " />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>运单号：</p>
        <el-input
          v-model="entrust.waybill_no"
          size="mini"
          style="width: 150px"
          placeholder="请输入运单号"
          @paste.native.capture.prevent="
            value => {
              return searchCopyFormat(value, 'waybill_no');
            }
          " />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>车架号：</p>
        <el-input
          v-model="entrust.frame_number"
          size="mini"
          style="width: 150px"
          placeholder="请输入车架号"
          @paste.native.capture.prevent="
            value => {
              return searchCopyFormat(value, 'frame_number');
            }
          " />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>委托商：</p>
        <el-input v-model="entrust.entrustIpt" size="mini" style="width: 150px" placeholder="请输入委托商" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>提车场点：</p>
        <el-input v-model="entrust.pickCar" size="mini" style="width: 150px" placeholder="请输入提车场点" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>起运地：</p>
        <el-input v-model="entrust.startArea" size="mini" style="width: 150px" placeholder="请输入起运地" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>目的地：</p>
        <el-input v-model="entrust.endArea" size="mini" style="width: 150px" placeholder="请输入目的地" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>起运港：</p>
        <el-input v-model="entrust.startPort" size="mini" style="width: 150px" placeholder="请输入起运港" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>目的港：</p>
        <el-input v-model="entrust.endPort" size="mini" style="width: 150px" placeholder="请输入目的港" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>收车单位：</p>
        <el-input v-model="entrust.collect" size="mini" style="width: 150px" placeholder="请输入收车单位" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>品牌：</p>
        <el-input v-model="entrust.brand" size="mini" style="width: 150px" placeholder="请输入品牌" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>运输方式：</p>
        <el-select v-model="entrust.termsIpt" size="mini" filterable style="width: 150px" placeholder="请选择状态">
          <el-option label="全部" value="" />
          <el-option label="公路" value="1" />
          <el-option label="水路" value="2" />
          <el-option label="水陆联运" value="3" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 400px">
        <p>计划时间：</p>
        <el-date-picker v-model="entrust.startTimeIpt" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="开始日期" />
        <span style="display: inline-block; width: 15px; text-align: center; font-size: 18px">-</span>
        <el-date-picker v-model="entrust.endTimeIpt" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="结束日期" />
      </div>
      <div class="navContainer" style="width: 230px">
        <p>锁定状态：</p>
        <el-select v-model="entrust.locking" size="mini" filterable style="width: 150px" placeholder="请选择锁定状态">
          <el-option label="全部" value="" />
          <el-option label="已锁定" value="1" />
          <el-option label="未锁定" value="2" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>状态：</p>
        <el-select v-model="entrust.stateIpt" size="mini" filterable style="width: 150px" placeholder="请选择状态">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>资源车：</p>
        <el-select v-model="entrust.virtualIdentity" size="mini" filterable style="width: 150px" placeholder="请选择是否资源车">
          <el-option v-for="item in whetherList" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="addBtn">新增</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer" ref="tableCot">
        <div class="update" style="display: flex; justify-content: space-between; font-size: 17px" :style="planType == 0 ? 'float:right' : ''">
          <el-popover v-if="planType == 1" placement="bottom" width="160" trigger="click" v-model="visible">
            <p>选择操作</p>
            <div>
              <el-radio-group v-model="checkList" class="elradio">
                <!-- <el-radio label="batch_number">删除批次号</el-radio> -->
                <!-- <el-radio label="waybill_no">删除运单号</el-radio> -->
                <el-radio label="frame_number">删除计划</el-radio>
                <!-- <el-radio label="modify_plan">修改计划信息</el-radio> -->
                <!-- <el-radio label="modify_vehicle">修改委托车信息</el-radio> -->
                <!-- <el-radio label="modify_line">修改线路信息</el-radio> -->
                <!-- <el-radio label="lock_plan">锁定计划</el-radio> -->
                <!-- <el-radio label="Unlock_plan">解锁计划</el-radio> -->
                <el-radio label="lock_vehicle">锁定委托车</el-radio>
                <el-radio label="Unlock_vehicle">解锁委托车</el-radio>
                <el-radio label="arrive_place">修改目的地</el-radio>
                <!--                <el-radio label="submit_modified_data_appy_for">提交修改数据申请</el-radio>-->
                <el-radio label="compulsory_delivery">强制交车</el-radio>
              </el-radio-group>
            </div>
            <div style="text-align: right; margin: 0">
              <el-button
                size="mini"
                type="text"
                @click="
                  () => {
                    this.visible = false;
                    this.checkList = '';
                  }
                "
                >取消
              </el-button>
              <el-button type="primary" size="mini" @click="BatchModify">确定</el-button>
            </div>
            <span slot="reference" style="cursor: pointer">批量操作</span>
          </el-popover>
          <div style="display: flex">
            <!-- <el-popover
              placement="bottom"
              width="160"
              trigger="click"
              v-model="visible2">
              <p>选择模板</p>
              <div >
                <div  class="elradio" style="display: flex; flex-direction: column;align-items: center;">
                  <span @click="download(1)" style="cursor: pointer;margin-bottom: 10px">公路/水路模板下载</span>
                  <span @click="download(2)" style="cursor: pointer;margin-bottom: 10px">水路联运模板下载</span>
                </div>
              </div>
              <span slot="reference" class="el-icon-download el-icon--right" style="cursor: pointer">模板下载</span >
            </el-popover> -->
            <span class="el-icon-download" @click="exportClick" style="cursor: pointer; font-size: 16px; margin-right: 20px; color: rgba(51, 136, 255, 1); display: flex; align-items: center">导出数据</span>
            <span class="el-icon-download" style="cursor: pointer; font-size: 16px; margin-right: 20px; color: rgba(51, 136, 255, 1); display: flex; align-items: center" @click="download">模板下载</span>
            <span style="cursor: pointer">
              <el-upload ref="upload" class="upload-demo" style="color: rgba(51, 136, 255, 1)" :disabled="uploadDis" :action="uploadUrl" :auto-upload="true" :show-file-list="false" :data="uploadData" :http-request="uploadHttp" :on-success="planOnSuccess" :before-upload="beforeUpload">
                <i class="el-icon-upload el-icon--right">批量导入</i>
              </el-upload>
            </span>
          </div>
        </div>
        <el-table
          v-if="planType == 0"
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          max-height="400"
          border
          key="table1"
          :header-cell-style="{
            color: '#3B3B3B',
            'font-size': '13px',
            height: '48px',
            background: '#E8E8E8',
          }"
          :cell-style="{
            color: '#7F7F7F',
            'font-size': '13px',
            height: '52px',
          }"
          :row-key="
            row => {
              return row.id;
            }
          "
          @select="handleCurrentChange"
          @select-all="handleCurrentChange"
          :row-style="rowStyle"
          :reserve-selection="true"
          ref="selectTable">
          <el-table-column type="selection" align="center" width="50px" :reserve-selection="true" />
          <el-table-column prop="consignorName" label="委托商" align="center" show-overflow-tooltip min-width="150" />
          <el-table-column prop="batchNumber" label="批次号" align="center" show-overflow-tooltip min-width="150" />
          <el-table-column prop="planTypeName" label="计划类型" align="center" show-overflow-tooltip min-width="100" />
          <el-table-column prop="transRulesType" label="运输条款" align="center" show-overflow-tooltip min-width="120" />
          <el-table-column prop="transportMode" label="运输方式" align="center" min-width="70">
            <template slot-scope="scope">{{ transRulesTypeFormat(scope.row.transportMode) }} </template>
          </el-table-column>
          <el-table-column prop="receiptType" label="回单类型" align="center" min-width="70">
            <template slot-scope="scope">{{ transReceiptType(scope.row.receiptType) }}</template>
          </el-table-column>
          <el-table-column prop="planCount" label="委托车数量" align="center" show-overflow-tooltip min-width="80" />
          <el-table-column prop="switchState" label="锁定状态" align="center">
            <template slot-scope="scope">{{ switchStateFormat(scope.row) }}</template>
          </el-table-column>
          <!-- <el-table-column prop="state" label="状态" align="center" min-width="70">
            <div slot-scope="scope">{{getState(scope.row.state)}}</div>
          </el-table-column> -->
          <el-table-column prop="createTime" label="创建时间" align="center" :formatter="getDate" min-width="100" />
          <el-table-column label="操作" min-width="270" align="center">
            <template slot-scope="scope">
              <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情 </el-button>
              <el-button v-if="scope.row.status !== 1" size="mini" type="primary" :loading="changeLoad" @click="changeClick(scope.row)" class="yellow-bg">修改 </el-button>
              <el-button v-if="scope.row.switchState == 0" size="mini" type="info" @click="lockingClick(scope.row.id)">锁定 </el-button>
              <el-button v-if="scope.row.switchState == 1" size="mini" type="primary" @click="unlockingClick(scope.row.id)">解锁 </el-button>
              <el-button v-if="scope.row.status !== 1" size="mini" type="danger" @click="deleteClick(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-table
          v-else
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          max-height="400"
          border
          key="table2"
          :header-cell-style="{
            color: '#3B3B3B',
            'font-size': '13px',
            height: '48px',
            background: '#E8E8E8',
          }"
          :cell-style="{
            color: '#7F7F7F',
            'font-size': '13px',
            height: '52px',
          }"
          :row-key="
            row => {
              return row.id;
            }
          "
          @select="handleCurrentChange"
          @select-all="handleCurrentChange"
          :row-style="rowStyle"
          ref="selectTable"
          :reserve-selection="true">
          <el-table-column type="selection" align="center" width="50px" :reserve-selection="true" />
          <el-table-column prop="batch_number" label="批次号" align="center" show-overflow-tooltip min-width="150" />
          <el-table-column prop="waybill_no" label="运单号" align="center" show-overflow-tooltip min-width="150" />
          <el-table-column prop="frame_number" label="车架号" align="center" show-overflow-tooltip min-width="150" />
          <el-table-column prop="consignor_name" label="委托商" align="center" show-overflow-tooltip min-width="150" />
          <el-table-column prop="pick_car" label="提车场点" align="center" show-overflow-tooltip min-width="150" />
          <el-table-column prop="departure_place" label="起运地" :formatter="startPlace" align="center" show-overflow-tooltip min-width="150" />
          <el-table-column prop="arrive_place" label="目的地" :formatter="endPlace" align="center" show-overflow-tooltip min-width="150" />
          <el-table-column prop="departure_port" label="起运港" align="center" min-width="100" />
          <el-table-column prop="arrive_port" label="目的港" align="center" min-width="100" />
          <el-table-column prop="collect_car" label="收车单位" align="center" show-overflow-tooltip min-width="80" />
          <el-table-column prop="brand_name" label="品牌" align="center" min-width="80" />
          <el-table-column prop="model_name" label="型号" align="center" show-overflow-tooltip min-width="80" />
          <el-table-column prop="transport_mode" label="运输方式" align="center" min-width="70">
            <template slot-scope="scope">{{ transRulesTypeFormat(scope.row.transport_mode) }} </template>
          </el-table-column>
          <el-table-column prop="plan_date" label="计划时间" align="center" min-width="140">
            <template slot-scope="scope">{{ getTime(scope.row.plan_date) }}</template>
          </el-table-column>
          <el-table-column prop="switch_state" label="锁定状态" align="center">
            <template slot-scope="scope">{{ switchStateFormat(scope.row) }}</template>
          </el-table-column>
          <el-table-column prop="state" label="状态" align="center" min-width="70">
            <div slot-scope="scope">{{ getState1(scope.row.state) }}</div>
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center">
            <template slot-scope="scope">
              <el-button size="mini" class="searchBtn" type="primary" @click="detailEntrusted(scope.row.id)">详情 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination background :page-sizes="[50, 100, 200, 400, 800, 1000]" layout="sizes,prev, pager, next,jumper" :total="total" :current-page.sync="page" @size-change="contractSizeChange" @current-change="contractCurrentChange" @prev-click="contractCurrentChange" @next-click="contractCurrentChange" />
      </div>
    </div>
    <el-dialog title="计划详情" :visible.sync="detailDialogVisible" width="880px" center top="10vh">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>基础信息</span>
            <p :style="getStyle(detailData.switchState)">
              {{ switchStateFormat2(detailData.switchState) }}
            </p>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">委托商：</span>
                <span>{{ detailData.consignorName }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">批次号：</span>
                <span>{{ detailData.batchNumber }}</span>
              </div>
              <div>
                <span class="span1">计划类型：</span>
                <span>{{ detailData.planTypeName }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">托运数量：</span>
                <span>{{ detailData.planCount }}</span>
              </div>
              <div>
                <span class="span1">剩余托运数量：</span>
                <span>{{ detailData.leftoverPlanCount }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">回单类型：</span>
                <span>{{ detailData.receiptType == 1 ? '电子回单' : detailData.receiptType == 2 ? '纸质回单' : '无' }}</span>
              </div>
              <div>
                <span class="span1">运输方式：</span>
                <span>{{ transportMode(detailData) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>委托车信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="detailData.transportChildCvList" border style="width: 100%" max-height="300px">
              <el-table-column label="序号" align="center" type="index" width="50px" />
              <el-table-column label="运单号" align="center" prop="waybillNo" min-width="80px" />
              <el-table-column label="车架号" align="center" prop="frameNumber" />
              <el-table-column label="计划时间" align="center" prop="planDate" min-width="120px" />
              <el-table-column label="起始区域" align="center" prop="departurePlace" />
              <el-table-column label="起始港" align="center" prop="departurePort" />
              <el-table-column label="交车港" align="center" prop="arrivePort" />
              <el-table-column label="交车区域" align="center" prop="arrivePlace" />
              <el-table-column label="品牌" align="center" prop="brandName" min-width="100px" />
              <el-table-column label="型号" align="center" prop="modelName" min-width="60px" />
              <el-table-column label="颜色" align="center" prop="color" />
              <el-table-column label="交接附件" align="center" prop="fileName" />
              <el-table-column prop="switchState" label="锁定状态" align="center">
                <template slot-scope="scope">
                  {{ switchStateFormat2(scope.row.switchState) }}
                </template>
              </el-table-column>
              <el-table-column prop="state" :formatter="formatter" label="状态" align="center" />
            </el-table>
          </div>
        </div>
        <!-- <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>审核信息</span>
          </div>
          <div style="width:70%">
            <steps :step-data="stepData" :step-state="stepState"/>
          </div>
        </div> -->
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>操作信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="operationData" border>
              <el-table-column label="操作时间" align="center" width="160px">
                <div slot-scope="scope">
                  {{ getTime(scope.row.createTime) }}
                </div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center" />
              <el-table-column prop="operationName" label="操作人" align="center" />
              <el-table-column prop="remark" label="备注" align="center" />
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="委托车详情" :visible.sync="entrustedVisible" width="700px" center top="10vh">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>运输计划信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">批次号：</span>
                <span>{{ entrustedData.batchNumber }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">委托商：</span>
                <span>{{ entrustedData.consignorName }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">计划类型：</span>
                <span>{{ entrustedData.planTypeName }}</span>
              </div>
              <div>
                <span class="span1">回单类型：</span>
                <span>{{ entrustedData.receiptType == 1 ? '电子回单' : '纸质回单' }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">运输条款：</span>
                <span>{{ entrustedData.transRulesType }}</span>
              </div>
              <div>
                <span class="span1">运输方式：</span>
                <span>{{ transportMode(entrustedData) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line" />
            <span>委托车信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">车架号：</span>
                <span>{{ entrustedData.transportChild ? entrustedData.transportChild.frameNumber : '' }}</span>
              </div>
              <div>
                <span class="span1">运单号：</span>
                <span>{{ entrustedData.transportChild ? entrustedData.transportChild.waybillNo : '' }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">计划时间：</span>
                <span>{{ entrustedData.transportChild ? entrustedData.transportChild.planDate : '' }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">提车场点：</span>
                <span>{{ entrustedData.transportChild ? entrustedData.transportChild.pickCar : '' }}</span>
              </div>
              <div>
                <span class="span1">收车单位：</span>
                <span>{{ entrustedData.transportChild ? entrustedData.transportChild.collectCar : '' }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">经销商：</span>
                <span>{{ entrustedData.transportChild ? entrustedData.transportChild.dealer : '' }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">品牌：</span>
                <span>{{ entrustedData.transportChild ? entrustedData.transportChild.brandName : '' }}</span>
              </div>
              <div>
                <span class="span1">型号：</span>
                <span>{{ entrustedData.transportChild ? entrustedData.transportChild.modelName : '' }}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">颜色：</span>
                <span>{{ entrustedData.transportChild ? entrustedData.transportChild.color : '' }}</span>
              </div>
              <div>
                <span class="span1">交接附件：</span>
                <span>{{ entrustedData.transportChild ? entrustedData.transportChild.fileName : '' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :width="dialogWidth" center @close="dialogClose" :close-on-click-modal="false">
      <div class="company">
        <el-form :model="teamData" label-width="90px" :rules="rules" ref="ruleForm" v-if="!steps">
          <div style="display: flex; align-items: flex-end">
            <div class="line" />
            <span>基础信息</span>
          </div>
          <div style="display: flex; flex-direction: column; padding: 10px 10px 0px 0px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="批次号：" prop="batch2">
                  <el-input style="width: 100%" v-model="teamData.batch2" placeholder="请输入批次号" autocomplete="off" size="small" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="计划类型：" prop="type">
                  <el-select filterable v-model="teamData.type" size="mini" style="width: 100%" placeholder="请选择计划类型" value-key="id">
                    <el-option v-for="item in typeOpiton" :key="item.id" :label="item.attrNm" :value="item.id" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="回单类型：" prop="receiptType">
                  <el-select filterable v-model="teamData.receiptType" size="mini" style="width: 100%" placeholder="请选择回单类型" value-key="id">
                    <el-option label="电子回单" :value="1" />
                    <el-option label="纸质回单" :value="2" />
                    <el-option label="无" :value="3" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="委托商：" prop="name">
                  <el-select filterable v-model="teamData.name" size="mini" style="width: 100%" placeholder="请输入委托商" value-key="id">
                    <el-option v-for="item in nameOption" :key="item.id" :label="item.customer_name" :value="item" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="运输条款：" prop="transportType1">
                  <el-select filterable v-model="teamData.transportType1" @change="shipTypeChange($event, 1)" size="mini" :disabled="dialogTitle == '修改运输计划'" style="width: 100%" placeholder="请选择运输条款">
                    <el-option label="主机厂库房" :value="'VDC'" />
                    <el-option label="港口" :value="'GK'" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label-width="0px" prop="transportType2">
                  <span style="display: inline-block; width: 15px; text-align: center">-</span>
                  <el-select filterable v-model="teamData.transportType2" @change="shipTypeChange($event, 2)" size="mini" :disabled="dialogTitle == '修改运输计划'" style="width: calc(100% - 15px)" placeholder="请选择运输条款">
                    <el-option label="港口" :value="'GK'" />
                    <el-option label="中转库" :value="'VSC'" />
                    <el-option label="经销商门店" :value="'DO'" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="运输方式：" prop="transport">
                  <el-select filterable v-model="teamData.transport" size="mini" @focus="verifyType" @change="transportChange" style="width: 100%" :disabled="dialogTitle == '修改运输计划'" placeholder="请选择运输方式" value-key="id">
                    <el-option v-for="item in typeOption" :key="item.id" :label="item.name" :value="item" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <div>
            <div style="display: flex; align-items: flex-end">
              <div class="line" />
              <span>委托车信息</span>
            </div>
            <div style="display: flex; align-items: center; justify-content: space-between; padding-top: 10px">
              <div style="display: flex; align-items: center; margin-left: 10px" class="inpt">
                <span style="color: #606266; font-weight: 700"><span style="color: red">*</span>委托车数量：</span>
                <el-input v-model="carNumber" size="mini" style="width: 150px" placeholder="请输入委托车数量" />
              </div>
            </div>
          </div>
          <div class="productTable" v-if="dialogTitle == '添加运输计划'">
            <el-table
              v-loading="changeTable"
              :data="addTable"
              max-height="300px"
              style="width: 100%"
              key="add"
              border
              :header-cell-style="{
                color: '#7F7F7F;',
                'font-size': '13px;',
                height: '48px;',
              }"
              :cell-style="{ color: '#7F7F7F;', 'font-size': '13px;' }"
              :header-cell-class-name="cellStyle">
              <el-table-column label="序号" align="center" type="index" width="50px" />
              <el-table-column label="运单号" class="refClass" align="center" prop="supplier" min-width="130">
                <input class="table-input" slot-scope="scope" v-model.lazy="addTable[scope.$index].supplier" placeholder="运单号" />
              </el-table-column>
              <el-table-column label="车架号" align="center" prop="num" min-width="130">
                <input class="table-input" slot-scope="scope" v-model.lazy="addTable[scope.$index].num" placeholder="车架号" />
              </el-table-column>
              <el-table-column label="计划时间" align="center" prop="time" min-width="100">
                <template slot-scope="scope">
                  <el-date-picker v-model="scope.row.time" size="mini" style="width: 100%" placeholder="请选择" type="datetime" value-format="yyyy-MM-dd HH:mm" />
                </template>
              </el-table-column>
              <el-table-column label="起始区域" align="center" v-show="!tranType.startAreaType" prop="startArea" min-width="100px">
                <template slot-scope="scope">
                  <el-cascader
                    size="mini"
                    style="width: 100%"
                    v-model="scope.row.startArea"
                    placeholder="请选择"
                    :options="areaOption"
                    :props="{
                      value: 'id',
                      label: 'cityName',
                      children: 'children',
                    }"
                    clearable
                    filterable />
                </template>
              </el-table-column>
              <el-table-column label="起始港" align="center" v-show="!tranType.startPortType" prop="startPort" min-width="100px">
                <template slot-scope="scope">
                  <el-select filterable @change="portChange($event, scope.$index, 'start')" v-model="scope.row.startPort" size="mini" style="width: 100%" placeholder="请选择" value-key="id">
                    <el-option v-for="item in portOption" :key="item.id" :label="item.supplier_name" :value="item" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="交车港" align="center" v-show="!tranType.endPortType" prop="endPort" min-width="100px">
                <template slot-scope="scope">
                  <el-select filterable @change="portChange($event, scope.$index, 'end')" v-model="scope.row.endPort" size="mini" style="width: 100%" placeholder="请选择" value-key="id">
                    <el-option v-for="item in portOption" :key="item.id" :label="item.supplier_name" :value="item" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="交车区域" align="center" prop="endArea" v-show="!tranType.endAreaType" min-width="100px">
                <template slot-scope="scope">
                  <el-cascader
                    size="mini"
                    style="width: 100%"
                    v-model="scope.row.endArea"
                    placeholder="请选择"
                    :options="areaOption"
                    :props="{
                      value: 'id',
                      label: 'cityName',
                      children: 'children',
                    }"
                    clearable
                    filterable />
                </template>
              </el-table-column>
              <el-table-column label="提车场点" align="center" prop="extract" min-width="100">
                <input class="table-input" slot-scope="scope" v-model.lazy="addTable[scope.$index].extract" placeholder="提车场点" />
              </el-table-column>
              <el-table-column label="收车单位" align="center" prop="charge" min-width="100">
                <input class="table-input" slot-scope="scope" v-model.lazy="addTable[scope.$index].charge" placeholder="收车单位" />
              </el-table-column>
              <el-table-column label="经销商" align="center" prop="dealer" min-width="100">
                <input class="table-input" slot-scope="scope" v-model.lazy="addTable[scope.$index].dealer" placeholder="经销商" />
              </el-table-column>
              <el-table-column label="车型" align="center" prop="brand" min-width="120">
                <el-cascader size="mini" slot-scope="scope" v-model="addTable[scope.$index].brand" :options="brandOption" :key="scope.$index" :props="{ value: 'id', label: 'model', children: 'carModel' }" @change="typeChange" filterable />
              </el-table-column>
              <el-table-column label="颜色" align="center" prop="color">
                <input class="table-input" slot-scope="scope" v-model.lazy="addTable[scope.$index].color" placeholder="颜色" />
              </el-table-column>
              <el-table-column label="交接附件" align="center" prop="remark">
                <input class="table-input" slot-scope="scope" v-model.lazy="addTable[scope.$index].remark" placeholder="附件" />
              </el-table-column>
              <el-table-column prop="operation" label="操作" align="center" width="50px">
                <div slot-scope="scope" style="display: flex; align-items: center; justify-content: center" v-if="addTable.length > 1">
                  <img alt="" :src="require('@/assets/images/u725.png')" :style="'width:22px;height:22px;cursor: pointer;'" @click="removeClick(scope.$index)" />
                </div>
                <div v-else>--</div>
              </el-table-column>
            </el-table>
            <div class="tableAddBtnContainer">
              <div class="AddContainer" @click="addCl">
                <img alt="" :src="require('@/assets/images/u131.png')" />
                <p>新增</p>
              </div>
            </div>
          </div>
          <div class="productTable1" v-else>
            <el-table
              v-loading="changeTable"
              :data="addTable"
              max-height="300px"
              style="width: 100%"
              key="edit"
              border
              :header-cell-style="{
                color: '#7F7F7F;',
                'font-size': '13px;',
                height: '48px;',
              }"
              :cell-style="{ color: '#7F7F7F;', 'font-size': '13px;' }"
              :header-cell-class-name="cellStyle">
              <el-table-column label="序号" align="center" type="index" width="50px" />
              <el-table-column label="运单号" class="refClass" align="center" prop="supplier" min-width="130" />
              <el-table-column label="车架号" align="center" prop="num" min-width="130" />
              <el-table-column label="计划时间" align="center" prop="time" min-width="120" />
              <el-table-column label="起始区域" align="center" v-if="!tranType.startAreaType" prop="departurePlace" min-width="100" />
              <el-table-column label="起始港" align="center" v-if="!tranType.startPortType" prop="departurePort" min-width="100" />
              <el-table-column label="交车港" align="center" v-if="!tranType.endPortType" prop="arrivePort" min-width="100" />
              <el-table-column label="交车区域" align="center" prop="arrivePortArea" v-if="!tranType.endAreaType" min-width="100" />
              <el-table-column label="提车场点" align="center" prop="extract" min-width="100" />
              <el-table-column label="收车单位" align="center" prop="charge" min-width="100" />
              <el-table-column label="经销商" align="center" prop="dealer" min-width="100" />
              <el-table-column label="车型" align="center" prop="brandName" min-width="120" />
              <el-table-column label="颜色" align="center" prop="color" />
              <el-table-column label="交接附件" align="center" prop="remark" />
              <el-table-column prop="operation" label="操作" align="center" width="80">
                <template slot-scope="scope">
                  <span class="el-icon-error del-style" @click="delClick(scope.row)"></span>
                  <span class="el-icon-edit-outline edit-style" @click="editClick(scope.row)"></span>
                </template>
              </el-table-column>
            </el-table>
            <div class="tableAddBtnContainer">
              <div class="AddContainer" @click="addClick">
                <img alt="" :src="require('@/assets/images/u131.png')" />
                <p>新增</p>
              </div>
            </div>
          </div>
          <div class="btnContainer">
            <el-button size="small" class="searchBtn" :loading="loading" @click="saveClick">保存 </el-button>
            <el-button size="small" class="resetBtn" @click="dialogClose">关闭</el-button>
          </div>
          <!-- </div> -->
        </el-form>
      </div>
    </el-dialog>
    <!-- 批量操作提示 -->
    <el-dialog class="BatchModifyC" width="450px" title="提示" :visible.sync="BatchModifyShow" :close-on-click-modal="false" @close="BatchModifyClose">
      <div style="padding: 0 20px 20px 20px">
        <div style="display: flex; align-items: center">
          <i class="el-icon-warning" style="font-size: 24px; color: orange"></i>
          <span>确认{{ checkList | BatchModify }}吗？已选择</span>
        </div>
        <div>
          <el-table
            :header-cell-style="{
              color: '#3B3B3B',
              padding: '5px 0px',
              'font-size': '13px',
              background: '#E8E8E8',
            }"
            :cell-style="{
              color: '#7F7F7F',
              padding: '5px 0px',
              'font-size': '13px',
              height: '52px',
            }"
            :data="checkTableData"
            style="width: 100%; margin-top: 10px">
            <el-table-column prop="batch_number" label="批次号" align="center" min-width="120" />
            <el-table-column prop="waybill_no" label="运单号" align="center" min-width="120" />
            <el-table-column prop="frame_number" label="车架号" align="center" min-width="120" />
          </el-table>
        </div>
        <!-- <div style="display: flex;flex-direction: column; align-items: flex-start;margin-left: 20px">
          <div v-for="(item,index) in checkTableData" :key="`${index}sd`" style="margin-bottom: 10px">
            <i style="color: blue;">
              {{
              ['lock_plan','Unlock_plan'].includes(checkList)
              ? item.project_plan : ['lock_vehicle','Unlock_vehicle'].includes(checkList)
              ? item.batch_number : item[checkList]}}
            </i>
          </div>
        </div> -->
        <div style="display: flex; justify-content: center; margin-top: 20px">
          <el-button size="mini" type="primary" :loading="tipSureLoading" @click="confirmBatchModify">确认</el-button>
          <el-button size="mini" type="info" @click="BatchModifyClose">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="修改委托车信息" :visible.sync="modifyVehicle" width="800px" center @close="modifyVehicleDialogClose" :close-on-click-modal="false">
      <div class="company" style="padding: 20px">
        <div-border v-if="checkList === 'modify_vehicle'" label="批量修改" :isNeed="true" style="padding: 20px 20px 10px 20px; text-align: center">
          <el-form :model="modifyVehicleForm" label-width="70px" :inline="true">
            <el-form-item label="运输条款：">
              <el-input v-model="modifyVehicleForm.terms" style="width: 150px" size="mini" placeholder="运输条款" />
            </el-form-item>
            <el-form-item label="运输方式：">
              <el-select v-model="modifyVehicleForm.month" filterable style="width: 150px" size="mini" placeholder="请选择运输方式">
                <el-option label="公路" :value="1" />
                <el-option label="水路" :value="2" />
                <el-option label="水陆联运" :value="3" />
              </el-select>
            </el-form-item>
            <el-form-item label="提车场点：">
              <el-input v-model="modifyVehicleForm.point" style="width: 150px" size="mini" placeholder="提车场点" />
            </el-form-item>
            <!-- <el-form-item label="车型：">
              <el-cascader
                size="mini"
                v-model="modifyVehicleForm.brand"
                :options="brandOption"
                :props="{value:'id',label:'model',children:'carModel'}"
                @change="typeChange" filterable
              />
            </el-form-item> -->
            <el-form-item label="起运地：">
              <el-select v-model="modifyVehicleForm.startPosition" filterable style="width: 150px" size="mini" placeholder="请选择起运地">
                <el-option label="公路" :value="1" />
                <el-option label="水路" :value="2" />
                <el-option label="水陆联运" :value="3" />
              </el-select>
            </el-form-item>
            <el-form-item label="目的地：">
              <el-select v-model="modifyVehicleForm.endPosition" filterable style="width: 150px" size="mini" placeholder="请选择目的地">
                <el-option label="公路" :value="1" />
                <el-option label="水路" :value="2" />
                <el-option label="水陆联运" :value="3" />
              </el-select>
            </el-form-item>
            <el-form-item label="起运港：">
              <el-select v-model="modifyVehicleForm.startPort" filterable style="width: 150px" size="mini" placeholder="请选择起运港">
                <el-option label="公路" :value="1" />
                <el-option label="水路" :value="2" />
                <el-option label="水陆联运" :value="3" />
              </el-select>
            </el-form-item>
            <el-form-item label="目的港：">
              <el-select v-model="modifyVehicleForm.endPort" filterable style="width: 150px" size="mini" placeholder="请选择目的港">
                <el-option label="公路" :value="1" />
                <el-option label="水路" :value="2" />
                <el-option label="水陆联运" :value="3" />
              </el-select>
            </el-form-item>
            <el-form-item label="收车单位：">
              <el-input v-model="modifyVehicleForm.unit" style="width: 150px" size="mini" placeholder="收车单位" />
            </el-form-item>
            <el-form-item label="计划时间：">
              <el-date-picker type="date" v-model="modifyVehicleForm.planTime" style="width: 150px" size="mini" placeholder="计划时间" />
            </el-form-item>
            <el-form-item label-width="0px" style="width: 100%; padding-right: 25px; text-align: right">
              <el-button size="mini" type="primary" @click="modifyVehicleSaveClick">批量修改</el-button>
              <el-button size="mini" class="resetBtn" @click="modifyVehicleReset">重置</el-button>
            </el-form-item>
          </el-form>
        </div-border>
        <div-border v-if="checkList === 'modify_line'" label="批量修改" :isNeed="true" style="padding: 20px">
          <el-form :model="modifyVehicleForm" label-width="70px" :inline="true">
            <el-form-item label="线路选择：">
              <el-select v-model="modifyVehicleForm.chooseLine" size="mini" filterable placeholder="请输入选择路线" value-key="id">
                <el-option v-for="item in modifyVehicleLineOption" :key="item.id" :label="item.line_name" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label-width="0px">
              <el-button size="mini" class="searchBtn" @click="modifyVehicleSaveClick">确认 </el-button>
            </el-form-item>
          </el-form>
        </div-border>
        <div class="productTable" style="margin-top: 10px">
          <el-table
            :data="modifyVehicleTable"
            style="width: 100%"
            border
            :header-cell-style="{
              color: '#7F7F7F;',
              fontsize: '13px;',
              height: '48px;',
            }"
            :cell-style="{ color: '#7F7F7F;', fontsize: '13px;' }"
            :row-key="
              row => {
                return row.id;
              }
            "
            @select="modifyVehicleHandleCurrentChange"
            @select-all="modifyVehicleHandleCurrentChange"
            ref="modifyVehicleTable">
            <el-table-column type="selection" align="center" width="50px" :reserve-selection="true" />
            <el-table-column label="委托商" align="center" prop="consignor_name" show-overflow-tooltip min-width="100px" />
            <el-table-column label="批次号" align="center" prop="batch_number" show-overflow-tooltip min-width="80px" />
            <el-table-column label="运单号" align="center" prop="waybill_no" show-overflow-tooltip min-width="80px" />
            <el-table-column label="车架号" align="center" show-overflow-tooltip prop="frame_number" />
            <el-table-column label="运输条款" align="center" prop="trans_rules_type" min-width="100px">
              <template slot-scope="scope">
                <el-input v-model="scope.row.trans_rules_type" size="mini" placeholder="请输入运输条款" />
              </template>
            </el-table-column>
            <el-table-column label="运输方式" align="center" prop="transport_mode" min-width="100px">
              <el-select slot-scope="scope" v-model="scope.row.transport_mode" filterable size="mini" placeholder="请选择运输方式">
                <el-option label="公路" :value="1" />
                <el-option label="水路" :value="2" />
                <el-option label="水陆联运" :value="3" />
              </el-select>
            </el-table-column>
            <el-table-column label="提车场点" align="center" prop="pick_car" min-width="100px">
              <template slot-scope="scope">
                <el-input v-model="scope.row.pick_car" size="mini" placeholder="请输入提车场点" />
              </template>
            </el-table-column>
            <el-table-column label="起运地" align="center" prop="departure_place" min-width="100px">
              <el-select slot-scope="scope" filterable v-model="scope.row.departure_place" size="mini" placeholder="请选择起运地" value-key="id">
                <el-option v-for="item in modifyVehicleLineOption" :key="item.id" :label="item.line_name" :value="item.id" />
              </el-select>
            </el-table-column>
            <el-table-column label="目的地" align="center" prop="arrive_port" min-width="100px">
              <el-select slot-scope="scope" filterable v-model="scope.row.arrive_port" size="mini" placeholder="请选择目的地" value-key="id">
                <el-option v-for="item in modifyVehicleLineOption" :key="item.id" :label="item.line_name" :value="item.id" />
              </el-select>
            </el-table-column>
            <el-table-column label="起运港" align="center" prop="departure_port" min-width="100px">
              <el-select slot-scope="scope" filterable v-model="scope.row.departure_port" size="mini" placeholder="请选择起运港" value-key="id">
                <el-option v-for="item in modifyVehicleLineOption" :key="item.id" :label="item.line_name" :value="item.id" />
              </el-select>
            </el-table-column>
            <el-table-column label="目的港" align="center" prop="arrive_port" min-width="100px">
              <el-select slot-scope="scope" filterable v-model="scope.row.arrive_port" size="mini" placeholder="请选择目的港" value-key="id">
                <el-option v-for="item in modifyVehicleLineOption" :key="item.id" :label="item.line_name" :value="item.id" />
              </el-select>
            </el-table-column>
            <el-table-column label="收车单位" align="center" prop="collect_car" min-width="100px">
              <template slot-scope="scope">
                <el-input v-model="scope.row.collect_car" size="mini" placeholder="请输入收车单位" />
              </template>
            </el-table-column>
            <el-table-column label="计划时间" align="center" width="100" prop="plan_time" />
            <el-table-column label="操作" min-width="100" align="center">
              <div slot-scope="scope" style="display: flex; align-items: center; justify-content: center" v-if="modifyVehicleTable.length > 1">
                <i class="el-icon-error" @click="removeVehicle(scope.$index)" style="cursor: pointer; font-size: 16px" />
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div class="btnContainer">
          <el-button size="small" class="searchBtn" @click="modifyVehicleSave">保存</el-button>
          <el-button size="small" class="resetBtn" @click="modifyVehicleDialogClose">关闭</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 运输计划——修改：委托车信息编辑 -->
    <el-dialog :title="editTitle" :visible.sync="editInfoShow" width="650px" @close="editInfoClose" center :append-to-body="true" :close-on-click-modal="false">
      <el-form :model="editData" style="padding: 30px 40px" size="small" label-width="100px" :rules="editRules" ref="editForm">
        <el-form-item label="运单号：" prop="supplier">
          <el-input style="width: 100%" v-model="editData.supplier" placeholder="请输入运单号" />
        </el-form-item>
        <el-form-item label="车架号：" prop="num">
          <el-input style="width: 100%" v-model="editData.num" placeholder="请输入车架号" />
        </el-form-item>
        <el-form-item label="计划时间：" prop="time">
          <el-date-picker v-model="editData.time" style="width: 100%" placeholder="请选择" type="datetime" value-format="yyyy-MM-dd HH:mm" />
        </el-form-item>
        <el-form-item label="起始区域：" v-if="!tranType.startAreaType" prop="startArea">
          <el-cascader style="width: 100%" v-model="editData.startArea" placeholder="请选择" :options="areaOption" :props="{ value: 'id', label: 'cityName', children: 'children' }" clearable filterable />
        </el-form-item>
        <el-form-item label="起始港：" v-if="!tranType.startPortType" prop="startPort">
          <el-select filterable @change="portEdit('start')" v-model="editData.startPort" style="width: 100%" placeholder="请选择" value-key="id">
            <el-option v-for="item in portOption" :key="item.id" :label="item.supplier_name" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="交车港：" v-if="!tranType.endPortType" prop="endPort">
          <el-select filterable @change="portEdit('end')" v-model="editData.endPort" style="width: 100%" placeholder="请选择" value-key="id">
            <el-option v-for="item in portOption" :key="item.id" :label="item.supplier_name" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="交车区域：" v-if="!tranType.endAreaType" prop="endArea">
          <el-cascader style="width: 100%" v-model="editData.endArea" placeholder="请选择" :options="areaOption" :props="{ value: 'id', label: 'cityName', children: 'children' }" clearable filterable />
        </el-form-item>
        <el-form-item label="提车场点：" prop="extract">
          <el-input style="width: 100%" v-model="editData.extract" placeholder="请输入提车场点" />
        </el-form-item>
        <el-form-item label="收车单位：" prop="charge">
          <el-input style="width: 100%" v-model="editData.charge" placeholder="请输入收车单位" />
        </el-form-item>
        <el-form-item label="经销商：" prop="dealer">
          <el-input style="width: 100%" v-model="editData.dealer" placeholder="请输入经销商" />
        </el-form-item>
        <el-form-item label="车型：" prop="brand">
          <el-cascader size="mini" style="width: 100%" v-model="editData.brand" :options="brandOption" :props="{ value: 'id', label: 'model', children: 'carModel' }" filterable />
        </el-form-item>
        <el-form-item label="颜色：" prop="color">
          <el-input style="width: 100%" v-model="editData.color" placeholder="请输入颜色" />
        </el-form-item>
        <el-form-item label="交接附件：" prop="remark">
          <el-input style="width: 100%" v-model="editData.remark" placeholder="请输入车架号" />
        </el-form-item>
        <el-form-item label-width="0" style="text-align: center">
          <el-button class="searchBtn" @click="editInfoSave">确认</el-button>
          <el-button class="resetBtn" @click="editInfoClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 修改目的地 -->
    <arrive-place ref="arrivePlaceRef" @search="searchBtn" @empty="empty" />
  </div>
</template>

<script>
  import { transportPlanCvPageList, entrustedCarPageList, deleteTransportPlan, lockingTransportPlan, unlockingTransportPlan, transportPlanCvDetail, transportPlanChDetail, updateCarList, entrustedEdit, entrustedCvDetail, entrustedAdd, getCarSerieList, getAddressDetail, getAddressAdd, entrustedDel, transportPlanCvUpdate, publicSelectLine, transportPlanCvDeleteBatchNumber, transportPlanCvDeleteBatchWaybillNumber, transportPlanCvDeleteBatchFrameNumber, transportPlanCvLockBatchPlan, transportPlanCvLockBatchEntrustCar, transportPlanCvUnlockBatchPlan, transportPlanCvUnlockBatchEntrustCar, transportPlanCvModifyBatchEntrustCar, transportPlanCvModifyBatchLineInfo, commit, entrustedExport, forceArrive } from '@/service/vehiclelog';
  import { getParam, customerInfoSelectList } from '@/service/getData';
  import steps from '@/components/steps';
  import { baseUrl } from '@/config/env';
  import { baseImgUrl } from '@/config/env';
  import { formatDateTime } from '@/config/mUtils';
  import divBorder from '@/components/divBorder';
  import Team from '@/views/basicfile/carriers/team';
  import { getImport, getImportUrl } from '@/service/getIP';
  import { getSessionStore } from '@/config/mUtils';
  import { supplierPublicSelectPort } from '@/service/vehiclelog';
  import ArrivePlace from '@/views/vehiclelog/planManage/components/transportPlan/ArrivePlace';

  export default {
    components: {
      ArrivePlace,
      Team,
      steps,
      divBorder,
    },
    data() {
      let dateItem = new Date(new Date().getTime() - 144 * 60 * 60 * 1000); //使用当天时间戳减去以前的时间毫秒（小时*分*秒*毫秒）
      let startDay = dateItem.getFullYear() + '-' + (dateItem.getMonth() + 1).toString().padStart(2, '0') + '-' + dateItem.getDate().toString().padStart(2, '0');
      let endDay = new Date().getFullYear() + '-' + (new Date().getMonth() + 1).toString().padStart(2, '0') + '-' + new Date().getDate().toString().padStart(2, '0');
      return {
        tipSureLoading: false,
        importLoading: false,
        condition: { waybillNo: '' },
        startDate: '',
        endDate: '',
        // planType: 0,   // 菜单切换
        uploadDis: false, // 批量导入状态
        // table表格列数据的显隐控制
        tableShow: {
          th1: true,
          th2: true,
          th3: true,
          th4: true,
          th5: true,
          th6: true,
          th7: true,
          th8: true,
          th9: true,
          th10: true,
          th11: true,
          th12: true,
          th13: true,
        },
        brandOption: [],
        typeOption: [],
        // 运输计划
        transport: {
          consignorName: '', // 委托商名称
          batchNumber: '', // 批次号
          transportMode: '', // 运输方式
          receiptType: '', // 回单类型
          switchState: '', // 锁定状态
          planType: '', // 计划类型
        },
        // 委托车
        entrust: {
          batchIpt: '', // 批次号
          waybill_no: '', //运单号
          frame_number: '', //车架号号
          entrustIpt: '', // 委托商
          pickCar: '', // 提车场点
          startArea: '', // 起运地
          endArea: '', // 目的地
          startPort: '', // 起运港
          endPort: '', // 目的港
          collect: '', // 收车单位
          brand: '', // 品牌
          termsIpt: '', // 运输方式
          startTimeIpt: startDay, // 计划时间 起始
          endTimeIpt: endDay, // 计划时间 结束
          locking: '', // 锁定状态
          stateIpt: '', // 状态
          virtualIdentity: '', //是否资源车
        },
        planType: 0,
        nameOption1: [],
        termsOption: [],
        whetherList: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 1,
            label: '是',
          },
          {
            value: 0,
            label: '否',
          },
        ],
        stateOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '待分配运输',
          },
          {
            value: 1,
            label: '已分配运输',
          },
          {
            value: 2,
            label: '运输中',
          },
          {
            value: 3,
            label: '已交车',
          },
        ],
        page: 1,
        size: 50,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        //运输计划导入
        uploadData: {
          mFile: '', //文件名
        },
        uploadUrl: '', //运输计划导入路径
        detailDialogVisible: false, // 计划详情
        detailData: {
          state: '',
          plan: '',
          batch: '',
          planNum: '',
          lineName: '',
          brandName: '',
          modelName: '',
          startingName: '',
          deliveryName: '',
          receiptType: '',
          type: '',
          terms: '',
          num: '',
          name: '',
          time: '',
          city: '',
          address: '',
          carNum: '',
        },
        operationData: [], // 计划详情 操作信息
        entrustedVisible: false, // 委托车详情
        entrustedData: {},
        dialogTitle: '', // 新增/修改 标题
        dialogVisible: false, // 新增/修改
        steps: 0,
        dialogWidth: '',
        carNumber: 1,
        brandMap: new Map(), //保存品牌型号id，名称
        modelMap: new Map(), //保存品牌型号id，名称
        visible: false, //批量修改显示
        visible2: false, //模板弹出框显示
        checkList: '', //批量修改选择的条件
        checkTableData: [], //表格多选
        BatchModifyShow: false, //批量修改弹窗
        tableId: '', //要删除的字段拼接
        modifyVehicle: false, //显示修改委托车
        modifyVehicleTable: [
          // transport:"",
          {
            batch_number: '',
            consignor_name: '',
            supplier: '',
            num: '',
            chooseLine: '',
            brand: '',
            color: '',
            remark: '',
          },
        ], //修改委托车表格
        modifyVehicleLineOption: [], //线路选择
        modifyVehicleForm: {
          //修改委托车  批量修改信息
          terms: '', //运输条款
          month: '', // 运输方式
          point: '', //提车场点
          startPosition: '', //起运地
          endPosition: '', //目的地
          startPort: '', // 起运港
          endPort: '', // 目的港
          unit: '', // 收车单位
          planTime: '', //计划时间
          chooseLine: '',
        },
        modifyVehicleCheckTableData: [], //修改委托车 表格多选
        loading: false,
        // 新增/修改 委托车表格
        addTable: [
          {
            supplier: '',
            num: '',
            extract: '',
            charge: '',
            dealer: '',
            startArea: '',
            endArea: '',
            startPort: '',
            endPort: '',
            startAreaType: true,
            endAreaType: true,
            startPortType: true,
            endPortType: true,
            brand: '',
            color: '',
            remark: '',
          },
        ],
        // 运输方式
        tranType: {
          startAreaType: false,
          startPortType: false,
          endPortType: false,
          endAreaType: false,
        },
        routerOption: [],
        // 新增/修改 表单数据
        teamData: {
          // plan:'',
          // batch:'',
          // number:'',
          type: '',
          terms: '', //运输方式
          name: '',
          time: '',
          router: {
            line_name: '',
            id: '',
          },
          brandModel: '', //品牌型号
          transportType1: '', //运输条款
          transportType2: '', //运输条款
          transport: '', // 运输方式
        },
        rules: {
          plan: [
            {
              required: true,
              message: '请选择预报计划',
              trigger: 'blur',
            },
          ],
          router: [
            {
              required: true,
              message: '请选择计划路线',
              trigger: 'change',
            },
          ],
          receiptType: [
            {
              required: true,
              message: '请选择回单类型',
              trigger: 'blur',
            },
          ],
          type: [
            {
              required: true,
              message: '请选择计划类型',
              trigger: 'change',
            },
          ],
          // transport:[
          //   { required: true, message: '请选择运输方式', trigger: 'change' },
          // ],
          transportType1: [
            {
              required: true,
              message: '请选择运输条款',
              trigger: 'change',
            },
          ],
          transportType2: [
            {
              required: true,
              message: '请选择运输条款',
              trigger: 'change',
            },
          ],
          batch2: [
            {
              required: true,
              message: '请输入批次号',
              trigger: 'blur',
            },
          ],
          brandModel: [
            {
              required: true,
              message: '请选择品牌型号',
              trigger: 'blur',
            },
          ],
          name: [
            {
              required: true,
              message: '请选择委托商',
              trigger: 'change',
            },
          ],
          // time:[
          //   { required: true, message: '请选择计划时间', trigger: 'change' },
          // ],
        },
        nameOption: [], // 委托商数据
        stepData: [
          {
            title: '张三发起',
            time: '2021-9-30 14:09:23',
            state: '',
            remark: '',
          },
          {
            title: '财务部 张三通过',
            time: '2021-9-30 14:09:23',
            state: 'success',
            remark: '原因xxxxxx',
          },
          {
            title: '技术部 李四拒绝',
            time: '2021-9-30 14:09:23',
            state: 'failure',
            remark: '原因xxxxxx',
          },
          {
            title: '张三重新发起',
            time: '2021-9-30 14:09:23',
            state: '',
            remark: '',
          },
        ],
        // 计划类型
        typeOpiton: [],
        // 区域列表
        areaOption: [],
        // 港口列表
        portOption: [],
        changeTable: false, // 修改 —— 委托车
        changeLoad: false,
        // 编辑委托车信息数据
        editId: '',
        editTitle: '',
        editInfoShow: false,
        editData: {},
        editRules: {
          supplier: {
            required: true,
            message: '请输入运单号',
            trigger: 'blur',
          },
          num: {
            required: true,
            message: '请输入车架号',
            trigger: 'blur',
          },
          time: {
            required: true,
            message: '请选择计划时间',
            trigger: 'blur',
          },
          startArea: {
            required: true,
            message: '请选择起始区域',
            trigger: 'blur',
          },
          endArea: {
            required: true,
            message: '请选择交车区域',
            trigger: 'blur',
          },
          startPort: {
            required: true,
            message: '请选择起始港',
            trigger: 'blur',
          },
          endPort: {
            required: true,
            message: '请选择交车港',
            trigger: 'blur',
          },
          extract: {
            required: true,
            message: '请输入提车场点',
            trigger: 'blur',
          },
          // charge: {
          //   required: true,
          //   message: '请输入收车单位',
          //   trigger: 'blur',
          // },
          brand: {
            required: true,
            message: '请选择车型',
            trigger: 'blur',
          },
        },
      };
    },
    computed: {
      stepState() {
        return function (state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
            default:
              return 'wait';
          }
        };
      },
      getStyle() {
        return val => {
          switch (val) {
            case 2:
              return 'color: rgba(51, 84, 131, 100);';
            case 1:
              return 'color: rgba(51, 84, 131, 100);';
            case 3:
              return 'color: rgba(51, 84, 131, 100);';
            case 0:
              return 'color: rgba(249, 166, 6, 1)';
            case 4:
              return 'color: rgba(249, 166, 6, 1)';
            case -1:
              return 'color:#F56C6C;';
          }
        };
      },
      getState() {
        return function (state) {
          switch (state) {
            case 0:
              return '待执行';
            case 1:
              return '执行中';
            case 2:
              return '已完成';
            case 3:
              return '部分完成';
            case 4:
              return '待提交审核';
            case -1:
              return '已取消';
          }
        };
      },
      getState1() {
        return function (state) {
          switch (state) {
            case 0:
              return '待分配运输';
            case 1:
              return '已分配运输';
            case 2:
              return '运输中';
            case 3:
              return '已交车';
          }
        };
      },
      getTime() {
        return function (time) {
          return time ? formatDateTime(time, 'yyyy-mm-dd hh:ii:ss') : '';
        };
      },
      transRulesTypeFormat() {
        return function (value) {
          let text = '';
          value = value ? value.toString() : value;
          switch (value) {
            case '1':
              text = '公路';
              break;
            case '2':
              text = '水路';
              break;
            case '3':
              text = '水陆联运';
              break;
          }
          return text;
        };
      },
      transReceiptType() {
        return function (value) {
          let text = '';
          value = value ? value.toString() : value;
          switch (value) {
            case '1':
              text = '电子回单';
              break;
            case '2':
              text = '纸质回单';
              break;
            case '3':
              text = '无';
              break;
          }
          return text;
        };
      },
      switchStateFormat() {
        return function (value) {
          if (value.switchState === 1 || value.switch_state === 1 || value.switch_state1 === 1) {
            return '已锁定';
          } else {
            return '未锁定';
          }
        };
      },
      //锁定状态
      switchStateFormat2() {
        return function (val) {
          switch (val) {
            case 0:
              return '未锁定';
            case 1:
              return '已锁定';
          }
        };
      },
    },
    mounted() {
      // this.getDefaultDate();
      this.areaOption = JSON.parse(getSessionStore('areaList'));
      this.init();
    },
    created() {
      window.onresize = () => {
        this.$nextTick(() => {
          let heightStyle = this.$refs.tableCot.offsetHeight;
          this.Height = heightStyle - 23;
        });
      };
      // let url = getUrl()
      // this.uploadUrl  = baseUrl +`/platform/transport-plan-cv/importExcelxls?access_token=${token}`
      this.uploadUrl = getImportUrl('/transport-plan-cv/importExcelxls');
    },
    methods: {
      async init() {
        //分页
        // await this._transportPlanCvPageList();
        // 港口
        await this._supplierPublicSelectPort();
        //查询委托商
        const res3 = await customerInfoSelectList();
        if (res3.status !== 0) {
          this.$message.error(res3.message);
        } else {
          this.nameOption = res3.data;
          this.nameOption1 = [
            {
              id: '',
              customer_name: '全部',
            },
            ...res3.data,
          ];
        }
        await this._planType();
        await this._brandData();
      },
      // 分页查询 —— 运输计划
      async _transportPlanCvPageList() {
        const obj = {
          consignorName: this.transport.consignorName, //委托商
          batchNumber: this.transport.batchNumber, //批次号
          transportMode: this.transport.transportMode,
          receiptType: this.transport.receiptType,
          switchState: this.transport.switchState,
          planTypeName: this.transport.planType,
          startTime: this.entrust.startTimeIpt,
          endTime: this.entrust.endTimeIpt,
          rows: this.size,
          page: this.page,
        };
        this.tableLoad = true;
        const res = await transportPlanCvPageList(obj);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      // 分页查询 —— 委托车
      async _entrustedCarPageList() {
        const obj = {
          batchNumber: this.entrust.batchIpt, //批次号
          consignorName: this.entrust.entrustIpt, //委托商
          waybillNo: this.entrust.waybill_no,
          frameNumber: this.entrust.frame_number,
          pickCar: this.entrust.pickCar, // 提车场点

          departurePlace: this.entrust.startArea, // 起运地
          arrivePlace: this.entrust.endArea, // 目的地
          departurePort: this.entrust.startPort, // 起运港
          arrivePort: this.entrust.endPort, // 目的港
          collectCar: this.entrust.collect, // 收车单位
          brandName: this.entrust.brand, // 品牌

          transportMode: this.entrust.termsIpt, //运输方式
          startTime: this.entrust.startTimeIpt,
          endTime: this.entrust.endTimeIpt,

          switchState: this.entrust.locking, // 锁定状态

          state: this.entrust.stateIpt,
          virtualIdentity: this.entrust.virtualIdentity,
          rows: this.size,
          page: this.page,
        };
        this.tableLoad = true;
        const res = await entrustedCarPageList(obj);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      // 查询
      searchBtn() {
        this.page = 1;
        if (this.planType == 0) {
          this._transportPlanCvPageList();
        } else {
          this._entrustedCarPageList();
        }
      },
      //清空单选框
      empty() {
        this.checkTableData = [];
        if (this.$refs.selectTable) this.$refs.selectTable.clearSelection();
      },
      // 重置
      resetBtn() {
        let dateItem = new Date(new Date().getTime() - 144 * 60 * 60 * 1000); //使用当天时间戳减去以前的时间毫秒（小时*分*秒*毫秒）
        let startDay = dateItem.getFullYear() + '-' + (dateItem.getMonth() + 1).toString().padStart(2, '0') + '-' + dateItem.getDate().toString().padStart(2, '0');
        let endDay = new Date().getFullYear() + '-' + (new Date().getMonth() + 1).toString().padStart(2, '0') + '-' + new Date().getDate().toString().padStart(2, '0');
        this.transport = {
          consignorName: '', // 委托商名称
          batchNumber: '', // 批次号
          transportMode: '', // 运输方式
          receiptType: '', // 回单类型
          switchState: '', // 锁定状态
          planType: '', // 计划类型
        };
        this.entrust = {
          batchIpt: '', // 批次号
          waybill_no: '', //运单号
          frame_number: '', //车架号号
          entrustIpt: '', // 委托商
          pickCar: '', // 提车场点
          startArea: '', // 起运地
          endArea: '', // 目的地
          startPort: '', // 起运港
          endPort: '', // 目的港
          collect: '', // 收车单位
          brand: '', // 品牌
          termsIpt: '', // 运输方式
          startTimeIpt: startDay, // 计划时间 起始
          endTimeIpt: endDay, // 计划时间 结束
          locking: '', // 锁定状态
          stateIpt: '', // 状态
          virtualIdentity: '', //是否资源车}
        };
      },
      // 切换菜单
      typeFun(val) {
        this.resetBtn();
        this.planType = val;
        this.TableDatas = [];
        this.$refs.selectTable.clearSelection();
        this.$refs.selectTable.clearSelection();
        /*if (this.planType == 0) {
        this._transportPlanCvPageList();
      } else {
        this._entrustedCarPageList();
      }*/
      },
      // 列样式
      cellStyle(data) {
        if (data.columnIndex !== 0 && data.column.label != '操作' && data.column.label != '交接附件' && data.column.label != '颜色' && data.column.label != '经销商' && data.column.label != '收车单位') {
          return 'require';
        } else {
          return '';
        }
      },
      //港口名称
      async _supplierPublicSelectPort() {
        let res = await supplierPublicSelectPort();
        if (res.status !== 0) return this.$message.error(res.message);
        this.portOption = res.data.map(item => {
          return {
            supplier_name: item.supplier_name,
            id: item.id,
          };
        });
      },
      // 时间格式转换
      transformTime(date) {
        if (date === null || date === undefined) return '';
        let d = new Date(date);
        let datetime = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
        return datetime;
      },
      // 时间长度处理
      getDate(row, column, cellValue) {
        if (cellValue) {
          return cellValue.substring(0, 10);
        } else {
          return '';
        }
      },
      // 结束时间
      dateChange(val) {
        if (this.entrust.endTimeIpt && this.entrust.startTimeIpt && this.entrust.endTimeIpt <= this.entrust.startTimeIpt) {
          if (val == this.entrust.endTimeIpt) this.entrust.endTimeIpt = '';
          if (val == this.entrust.startTimeIpt) this.entrust.startTimeIpt = '';
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      //查询计划类型
      async _planType() {
        const res4 = await getParam({ categoryCd: 'contract_price' });
        if (res4.status !== 0) {
          this.$message.error(res4.message);
        } else {
          this.typeOpiton = res4.data.map(item => {
            return {
              attrNm: item.classaName,
              id: item.id,
            };
          });
        }
        // console.log(this.typeOpiton)
      },
      //查询委托车品牌信息
      async _brandData() {
        const res5 = await getCarSerieList();
        if (res5.status !== 0) {
          this.$message.error(res5.message);
        } else {
          this.brandOption = res5.data.map(item => {
            item.carModel.forEach(carItem => {
              this.modelMap.set(carItem.id, carItem.model);
              this.brandMap.set(carItem.brand_id, carItem.brand_name);
            });
            return {
              ...item,
              model: item.brand,
            };
          });
        }
      },
      async handleSelect(value) {
        // this.teamData.batch=value.batch_number;
        // this.teamData.number=value.plan_number;
        this.teamData.time = value.plan_time;
        this.teamData.name = {
          id: value.consignor_id,
          customer_name: value.consignor_name,
        };
        this.carNumber = value.plan_count;
      },
      async addTableChange(index) {
        const res = await getAddressDetail(this.addTable[index].name.id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.addTable[index].address = res.data.addressName;
        this.addTable[index].coordinate = res.data.coordinate;
      },
      typeChange(val) {
        console.log(val);
      },
      //委托车 操作删除
      removeClick(index) {
        this.addTable.splice(index, 1);
      },
      // 新增/修改 —— 确认
      async saveClick() {
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            if (this.carNumber === '') return this.$message.warning('请输入委托车数量！');
            if (Number(this.carNumber) < this.addTable.length) return this.$message.warning('超出委托车数量！');
            // for (let i = 0; i < this.addTable.length; i++) {
            //   for (let j in this.addTable[i]) {
            //     if (j == 'color' && !this.addTable[i][j]) this.addTable[i][j] = '无';
            //     if (j == 'remark' && !this.addTable[i][j]) this.addTable[i][j] = '无';
            //     if (j == 'dealer' && !this.addTable[i][j]) this.addTable[i][j] = '无';
            //     if (j == 'arrivePort' && !this.addTable[i][j]) this.addTable[i][j] = '无';
            //     if (j == 'arrivePortArea' && !this.addTable[i][j]) this.addTable[i][j] = '无';
            //     if (j == 'departurePlace' && !this.addTable[i][j]) this.addTable[i][j] = '无';
            //     if (j == 'departurePort' && !this.addTable[i][j]) this.addTable[i][j] = '无';
            //     if (j == 'transport' && !this.addTable[i][j]) continue;
            //     if (j == 'startAreaType' || j == 'endAreaType' || j == 'startPortType' || j == 'endPortType') continue;
            //     if (j == 'startArea' && this.addTable[i][j]) continue;
            //     if (j == 'endArea' && this.addTable[i][j]) continue;
            //     if (j == 'startPort' && this.addTable[i][j]) continue;
            //     if (j == 'endPort' && this.addTable[i][j]) continue;
            //     if (this.addTable[i]['num'] == null || this.addTable[i]['num'] == '' || this.addTable[i]['num'] == undefined) continue;
            //     if (!this.addTable[i][j]) {
            //       return this.$message.warning('每一项必须填完！');
            //     }
            //   }
            // }
            const arr = this.addTable.map(item => {
              return {
                waybillNo: item.supplier,
                frameNumber: item.num,
                modelId: item.brand[1],
                planDate: item.time,

                departurePlaceId: item.startArea[item.startArea.length - 1],
                arrivePlaceId: item.endArea[item.endArea.length - 1],
                departurePortId: item.startPort.id,
                arrivePortId: item.endPort.id,

                color: item.color,
                fileName: item.remark,
                distributor: item.dealer,
                pickCar: item.extract,
                collectCar: item.charge,
              };
            });
            let str = '';
            this.typeOpiton.forEach(item => {
              if (item.id === this.teamData.type) str = item.attrNm;
            });
            let obj = {
              id: this.teamData.id,
              batchNumber: this.teamData.batch2,
              planTypeId: this.teamData.type,
              planTypeName: str,
              transRulesType: this.teamData.transportType1 + '-' + this.teamData.transportType2, //运输条款
              consignorId: this.teamData.name.id,
              consignorName: this.teamData.name.customer_name,
              planCount: this.carNumber,
              transportMode: this.teamData.transport.id,
              receiptType: this.teamData.receiptType,
              type: !this.planType ? 1 : 2,
              // transportChildCvList:arr,
            };
            if (this.dialogTitle == '添加运输计划') {
              obj.transportChildCvList = arr;
            }
            this.loading = true;
            const res = this.dialogTitle === '添加运输计划' ? await getAddressAdd(obj) : await transportPlanCvUpdate(obj);
            this.loading = false;
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            if (this.planType == 0) {
              await this._transportPlanCvPageList();
            } else {
              await this._entrustedCarPageList();
            }
            this.dialogVisible = false;
            this.$refs.ruleForm.resetFields();
            this.steps = 0;
          } else {
          }
        });
      },
      //委托车 新增
      addCl() {
        if (Number(this.carNumber) < this.addTable.length + 1) return this.$message.warning('超出委托车数量！');
        for (let i = 0; i < this.addTable.length; i++) {
          for (let j in this.addTable[i]) {
            if (j === 'color' && !this.addTable[i][j]) continue;
            if (j === 'remark' && !this.addTable[i][j]) continue;
            if (j === 'dealer' && !this.addTable[i][j]) continue;
            if (j == 'transport' && !this.addTable[i][j]) continue;
            if (j == 'startAreaType' || j == 'endAreaType' || j == 'startPortType' || j == 'endPortType') continue;
            if (j == 'startArea' && this.addTable[i]['startAreaType']) continue;
            if (j == 'endArea' && this.addTable[i]['endAreaType']) continue;
            if (j == 'startPort' && this.addTable[i]['startPortType']) continue;
            if (j == 'endPort' && this.addTable[i]['endPortType']) continue;
            if (this.addTable[i]['num'] == null || this.addTable[i]['num'] == '' || this.addTable[i]['num'] == undefined) continue;
            if (!this.addTable[i][j]) {
              return this.$message.warning('每一项必须填完！');
            }
          }
        }
        this.addTable.push({
          supplier: '',
          num: '',
          startArea: '',
          time: '',
          endArea: '',
          startPort: '',
          endPort: '',
          brand: '',
          color: '',
          remark: '',
          startAreaType: true,
          endAreaType: true,
          startPortType: true,
          endPortType: true,
        });
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        if (this.planType == 0) {
          this._transportPlanCvPageList();
        } else {
          this._entrustedCarPageList();
        }
      },
      contractCurrentChange(page) {
        this.page = page;
        if (this.planType == 0) {
          this._transportPlanCvPageList();
        } else {
          this._entrustedCarPageList();
        }
      },
      // 运输计划/委托车 —— 新增
      async addBtn() {
        this.teamData = {
          // plan:'',
          // batch:'',
          // number:'',
          type: '',
          terms: '',
          name: '',
          time: '',
          router: {
            line_name: '',
            id: '',
          },
          brandModel: '', //品牌型号
          transportType1: '', //运输条款
          transportType2: '', //运输条款
        };
        this.dialogTitle = '添加运输计划';
        this.loading = true;
        this.dialogWidth = '1000px';
        this.loading = false;
        this.dialogVisible = true;
      },
      async exportClick() {
        let token = getSessionStore('token');
        let url;
        if (this.planType) {
          let param = {
            batchNumber: this.entrust.batchIpt,
            waybillNo: this.condition.waybillNo,
            consignorName: this.entrust.entrustIpt,
            frameNumber: this.entrust.frame_number,
            pickCar: this.entrust.pickCar,
            departurePlace: this.entrust.startArea,
            arrivePlace: this.entrust.endArea,
            departurePort: this.entrust.startPort,
            arrivePort: this.entrust.endPort,
            collectCar: this.entrust.collect,
            brandName: this.entrust.brand,
            transportMode: this.entrust.termsIpt,
            startDateExport: this.transformTime(this.entrust.startTimeIpt),
            endDateExport: this.transformTime(this.entrust.endTimeIpt),
            switchState: this.entrust.locking,
            state: this.entrust.stateIpt,
          };
          url = baseUrl + '/platform/transportChild/childCvExport' + '?access_token=' + token;
          window.exportExcel(url, param, '委托车表');
          // url += '?batchNumber=' + this.entrust.batchIpt + '&waybillNo=' + this.condition.waybillNo;
          // url += '&consignorName=' + this.entrust.entrustIpt + '&frameNumber=' + this.entrust.frame_number;
          // url += '&pickCar=' + this.entrust.pickCar + '&departurePlace=' + this.entrust.startArea;
          // url += '&arrivePlace=' + this.entrust.endArea + '&departurePort=' + this.entrust.startPort;
          // url += '&arrivePort=' + this.entrust.endPort + '&collectCar=' + this.entrust.collect;
          // url += '&brandName=' + this.entrust.brand + '&transportMode=' + this.entrust.termsIpt;
          // url += '&startDateExport=' + this.transformTime(this.entrust.startTimeIpt) + '&endDateExport=' + this.transformTime(this.entrust.endTimeIpt);
          // url += '&switchState=' + this.entrust.locking + '&state=' + this.entrust.stateIpt;
        } else {
          // url = baseUrl + '/platform/transport-plan-cv/planCvExport';
          // url += '?batchNumber=' + this.transport.batchNumber;
          // url += '&consignorName=' + this.transport.consignorName;
          // url += '&planTypeName=' + this.transport.planType;
          // url += '&transportMode=' + this.transport.transportMode;
          // url += '&receiptType=' + this.transport.receiptType;
          // url += '&switchState=' + this.transport.switchState;
          // url += '&startTime2=' + this.transformTime(this.entrust.startTimeIpt);
          // url += '&endTime2=' + this.transformTime(this.entrust.endTimeIpt);
          // url += '&access_token=' + token;
          // window.location.href = url;
          window.exportExcelGetNew('/platform/transport-plan-cv/planCvExport', {
            batchNumber: this.transport.batchNumber,
            consignorName: this.transport.consignorName,
            planTypeName: this.transport.planType,
            transportMode: this.transport.transportMode,
            receiptType: this.transport.receiptType,
            switchState: this.transport.switchState,
            startTime2: this.transformTime(this.entrust.startTimeIpt),
            endTime2: this.transformTime(this.entrust.endTimeIpt)
          });
        }
      },
      // 运输计划 —— 详情
      async detailClick(id) {
        const res = await transportPlanCvDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailDialogVisible = true;
        this.detailData = res.data;
        this.operationData = res.data.operateRecordList;
        this.stepData = res.data.contractExamineAffairsList
          ? res.data.contractExamineAffairsList.map(item => {
              return {
                time: item.createTime,
                remark: item.remark,
                state: item.type,
                title: item.authorName + item.typeDesc,
              };
            })
          : [];
      },
      // 运输计划 —— 锁定
      lockingClick(id) {
        this.$confirm('确定要锁定当前计划吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await lockingTransportPlan(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._transportPlanCvPageList();
          })
          .catch(() => {});
      },
      // 运输计划 —— 解锁
      unlockingClick(id) {
        this.$confirm('确定要解锁当前计划吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await unlockingTransportPlan(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._transportPlanCvPageList();
          })
          .catch(() => {});
      },
      // 运输计划 —— 删除
      deleteClick(id) {
        this.$confirm('确定要删除当前计划吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await deleteTransportPlan(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._transportPlanCvPageList();
          })
          .catch(() => {});
      },
      // 运输计划 —— 修改
      async changeClick(item) {
        this.dialogTitle = '修改运输计划';
        this.dialogWidth = '800px';
        this.editId = {
          id: item.id,
          transport: '',
        };
        this.changeLoad = true;
        const res = await transportPlanChDetail(item.id);
        this.changeLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.teamData = {
          id: res.data.id,
          receiptType: res.data.receiptType,
          batch2: res.data.batchNumber,
          type: res.data.planTypeId,
          transportType1: res.data.transRulesType.toString().split('-')[0],
          transportType2: res.data.transRulesType.toString().split('-')[1],
          name: {
            id: res.data.consignorId,
            customer_name: res.data.consignorName,
            coordinate: res.data.coordinate,
          },
          transport: {},
        };
        this.verifyType();
        this.teamData.transport = {
          name: this.transportMode(res.data),
          id: res.data.transportMode,
        };
        this.editId.transport = this.teamData.transport;
        this.getCarList(item.id);
        this.dialogVisible = true;
        this.$nextTick(async () => {
          // this.lazyLoading(res.data.transportChildCvList);
          this.transportChange(this.editId.transport);
          // 委托车数量
          this.carNumber = res.data.planCount;
        });
      },
      // 运输计划 —— 修改：获取委托车信息
      async getCarList(id) {
        this.changeTable = true;
        const res = await updateCarList(id);
        this.changeTable = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.addTable = [];
        if (res.data && res.data.length > 0) {
          res.data.forEach(list => {
            // 起始区域、轿车区域
            // let start = [], end = [];
            // if(list.departurePlaceId){
            //   start = [list.departurePlaceId.substr(0,2)+'0000',list.departurePlaceId.substr(0,4)+'00',list.departurePlaceId];
            // }
            // if(list.arrivePlaceId){
            //   end = [list.arrivePlaceId.substr(0,2)+'0000',list.arrivePlaceId.substr(0,4)+'00',list.arrivePlaceId];
            // }
            this.addTable.push({
              id: list.id,
              supplier: list.waybillNo,
              num: list.frameNumber,
              time: list.planDate,
              brand: [list.brandId, list.modelId],
              brandName: list.brandName + '/' + list.modelName,
              startArea: list.departurePlaceFullId ? list.departurePlaceFullId.split('/') : [],
              departurePlace: list.departurePlace,
              endArea: list.arrivePlaceFullId ? list.arrivePlaceFullId.split('/') : [],
              arrivePortArea: list.arrivePlace,
              startPort: {
                id: list.departurePortId,
                supplier_name: list.departurePort,
              },
              departurePort: list.departurePort,
              endPort: {
                id: list.arrivePortId,
                supplier_name: list.arrivePort,
              },
              arrivePort: list.arrivePort,
              dealer: list.distributor,
              remark: list.fileName,
              extract: list.pickCar,
              charge: list.collectCar,
            });
          });
        }
        // this.transportChange(this.editId.transport);
      },
      // 运输计划 —— 修改：委托车新增
      addClick() {
        if (Number(this.carNumber) < this.addTable.length + 1) return this.$message.warning('超出委托车数量！');
        this.editTitle = '新增委托车';
        this.editData = {};
        this.editInfoShow = true;
      },
      // 运输计划 —— 修改：委托车删除
      delClick(row) {
        this.$confirm('确定要删除当前委托车吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await entrustedDel(row.id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.getCarList(this.editId.id);
          })
          .catch(() => {});
      },
      // 运输计划 —— 修改：打开委托车编辑弹窗
      editClick(row) {
        this.editTitle = '修改委托车';
        this.editData = JSON.parse(JSON.stringify(row));
        this.editInfoShow = true;
      },
      // 运输计划 —— 修改：委托车编辑-港口改变
      portEdit(type) {
        if (this.editData.startPort == this.editData.endPort) {
          if (type == 'start') {
            this.editData.startPort = '';
          }
          if (type == 'end') {
            this.editData.endPort = '';
          }
          return this.$message.warning('起始港口与交车港口不能相同！');
        }
      },
      // 运输计划 —— 修改：委托车编辑-确认
      editInfoSave() {
        this.$refs.editForm.validate(async valid => {
          if (valid) {
            let { startArea, endArea } = this.editId;
            let obj = {
              basicId: this.editId.id,
              waybillNo: this.editData.supplier,
              frameNumber: this.editData.num,
              modelId: this.editData.brand[1],
              planDate: this.editData.time,

              departurePlaceId: startArea && startArea.length ? startArea[startArea.length - 1] : '',
              arrivePlaceId: endArea && endArea.length ? endArea[endArea.length - 1] : '',
              departurePortId: this.editData.startPort.id,
              arrivePortId: this.editData.endPort.id,

              color: this.editData.color,
              fileName: this.editData.remark,
              distributor: this.editData.dealer,
              pickCar: this.editData.extract,
              collectCar: this.editData.charge,
            };
            if (this.editTitle != '新增委托车') {
              obj.id = this.editData.id;
            }
            const res = this.editTitle == '新增委托车' ? await entrustedAdd(obj) : await entrustedEdit(obj);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this.editData = {};
            this.$refs.editForm.resetFields();
            this.editInfoShow = false;
            this.getCarList(this.editId.id);
          } else {
            return false;
          }
        });
      },
      // 运输计划 —— 修改：委托车编辑-取消
      editInfoClose() {
        this.editData = {};
        this.$refs.editForm.resetFields();
        this.editInfoShow = false;
      },
      // 将一维数组转为二维数组
      arrPages(arr, len) {
        const pages = [];
        arr.forEach((item, index) => {
          const page = Math.floor(index / len);
          if (!pages[page]) {
            pages[page] = [];
          }
          pages[page].push(item);
        });
        return pages;
      },
      // 滚动加载
      lazyLoading(table) {
        if (table.length <= 0) return (this.addTable = []);
        if (table.length <= 7) return this.changeTableShow(table, true);
        let lists = this.arrPages(table, 7);
        this.changeTableShow(lists[0], true);
        let len = Math.ceil(table.length / 7);
        let cur = Math.ceil(this.addTable.length / 7);
        let dom = document.querySelector('.el-table__body-wrapper.is-scrolling-left');
        dom.addEventListener('scroll', v => {
          const scrollDistance = dom.scrollHeight - dom.scrollTop - dom.clientHeight;
          console.log('鼠标滑动-scrollDistance', scrollDistance);
          if (scrollDistance <= 1) {
            //等于0证明已经到底，可以请求接口
            if (cur >= len) {
              console.log('我~是有底线的 (～￣▽￣)～');
            }
            if (cur < len) {
              this.changeTable = true;
              //当前页数小于总页数就请求
              this.changeTableShow(lists[cur], false);
              cur++; //当前页数自增
            }
          }
        });
      },
      // 修改 —— 运输车表格
      changeTableShow(table, flg) {
        if (flg) this.addTable = [];
        if (table.length > 0) {
          table.forEach(item => {
            // 起始区域、轿车区域
            let start = [],
              end = [];
            if (item.departurePlaceId) {
              start = [item.departurePlaceId.substr(0, 2) + '0000', item.departurePlaceId.substr(0, 4) + '00', item.departurePlaceId];
            }
            if (item.arrivePlaceId) {
              end = [item.arrivePlaceId.substr(0, 2) + '0000', item.arrivePlaceId.substr(0, 4) + '00', item.arrivePlaceId];
            }
            this.addTable.push({
              supplier: item.waybillNo,
              num: item.frameNumber,
              time: item.planDate,
              brand: [item.brandId, item.modelId],
              startArea: item.departurePlaceId ? start : [],
              endArea: item.arrivePlaceId ? end : [],
              startPort: {
                id: item.departurePortId,
                supplier_name: item.departurePort,
              },
              endPort: {
                id: item.arrivePortId,
                supplier_name: item.arrivePort,
              },
              color: item.color,
              remark: item.fileName,
              dealer: item.dealer,
              extract: item.pickCar,
              charge: item.collectCar,
            });
          });
          this.$nextTick(() => {
            this.changeTable = false;
          });
        }
      },
      // 委托车 —— 详情
      async detailEntrusted(id) {
        const res = await entrustedCvDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        if (res.data.transRulesType) {
          let temp = res.data.transRulesType.split('-');
          if (temp[0] == 'GK') {
            temp[0] = '港口';
          } else {
            temp[0] = '主机厂库房';
          }
          if (temp[1] == 'GK') {
            temp[1] = '港口';
          } else if (temp[1] == 'VSC') {
            temp[1] = '到中专库、区域';
          } else {
            temp[1] = '到经销商门店';
          }
          res.data.transRulesType = temp.join('-');
        }
        this.entrustedData = res.data;

        this.entrustedVisible = true;
      },
      /**
       * value  线路类型
       * type 判断是否是自动触发  ，回显触发不发出警告
       * */
      async termsRadioChange(value, type) {
        // this.teamData.router =''
        const res7 = await publicSelectLine({ type: value });
        if (res7.status !== 0) {
          this.$message.error(res7.message);
        } else {
          this.routerOption = res7.data.map(item => {
            return {
              line_name: item.line_name,
              id: item.id,
            };
          });
        }
        for (let addTableElement of this.addTable) {
          addTableElement.chooseLine = '';
        }
        if (type !== 1) this.$message.warning('请重新选择线路');
      },
      dialogClose() {
        this.steps = 0;
        this.dialogVisible = false;
        this.$refs.ruleForm.resetFields();
        this.carNumber = 1;
        //恢复默认值
        this.$data.addTable = this.$options.data().addTable;
      },
      /**
       *运输计划 导入 成功函数
       * @param res 上传成功回调
       */
      planOnSuccess(res) {
        this.uploadDis = false;
        this.importLoading = false;
        if (res.status !== 0) return this.$message.warning(res.message);
        this.$message.success(res.message);
        this._transportPlanCvPageList();
        // this.TableDatas = res.data;
        this.$forceUpdate();
      },
      beforeUpload(file) {
        this.importLoading = true;
        this.uploadDis = true;
        if (file.name.split('.')[file.name.split('.').length - 1] == 'xls' || file.name.split('.')[file.name.split('.').length - 1] == 'xlsx') {
          this.uploadData.mFile = file.name;
        } else {
          this.uploadDis = false;
          this.importLoading = false;
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      uploadHttp(content) {
        let formData = new FormData();
        formData.append('file', content.file, content.file.name);
        let that = this;
        this.$axios({
          method: 'post',
          url: content.action,
          timeout: 600 * 1000,
          data: formData,
          headers: { 'content-type': 'multipart/form-data' },
        })
          .then(res => {
            this.uploadDis = false;
            this.importLoading = false;
            console.log(res.data);
            // if (res.data.status !== 0) return that.$message.warning(res.data.message);
            // that.$message.success(res.data.message);
            that.$alert(res.data.message, '提示', {
              confirmButtonText: '关闭',
              callback: async () => {
                that.planType ? await that._entrustedCarPageList() : await that._transportPlanCvPageList();
              },
            });
          })
          .catch(error => {
            if (error.response) {
              that.$message.error('配时文件上传失败(' + error.response.status + ')，' + error.response.data);
              console.log('配时文件上传失败(' + error.response.status + ')，' + error.response.data);
            } else if (error.request) {
              that.$message.error('配时文件上传失败，服务器端无响应');
              console.log('配时文件上传失败，服务器端无响应');
            } else {
              that.$message.error('配时文件上传失败，请求封装失败');
              console.log('配时文件上传失败，请求封装失败');
            }
            this.uploadDis = false;
            this.importLoading = false;
          });
      },

      // 委托车状态
      formatter(row) {
        let text = '';
        switch (row.state) {
          case 0:
            text = '待分配运输';
            break;
          case 1:
            text = '已分配运输';
            break;
          case 2:
            text = '运输中';
            break;
          case 3:
            text = '已交车';
            break;
        }
        return text;
      },
      //模板下载
      download() {
        window.location.href = '/file/运输计划导入模板.xlsx';
      },
      //批量操作确定
      async BatchModify() {
        if (this.checkList === '') {
          this.$message.warning('请选择操作');
          return;
        }
        if (this.checkTableData.length === 0) {
          this.$message.warning('请选择需要操作的数据');
          return;
        }
        //操作为删除批次号,删除运单号，或删除车架号时
        if (['batch_number', 'waybill_no', 'frame_number'].includes(this.checkList)) {
          // isOutStorage 0 未出库
          // state 0待分配运输 不让删除
          let tableId = '';
          // for (let [index, checkTableDatum] of this.checkTableData.entries()) {
          //   if (checkTableDatum.is_out_storage === 1) {
          //     return this.$message.warning(`已出库不能删除`);
          //   } else if (checkTableDatum.state !== 0) {
          //     return this.$message.warning(`该状态不能删除`);
          //   }
          // }
          //去重，不能重复
          let map = new Map();
          for (let checkTableDatum of this.checkTableData) {
            map.set(checkTableDatum[this.checkList], checkTableDatum);
          }
          //清空重新赋值
          this.checkTableData = [];
          for (let value of map.values()) {
            this.checkTableData.push(value);
            if (this.checkList == 'frame_number') {
              tableId += value['id'] + ',';
            } else if (this.checkList == 'waybill_no') {
              tableId += value['batch_number'] + '/' + value['waybill_no'] + ',';
            } else {
              tableId += value[this.checkList] + ',';
            }
          }
          this.BatchModifyShow = true;
          //去掉 末尾逗号
          this.tableId = tableId.slice(0, tableId.length - 1);
        } else if (['lock_plan', 'lock_vehicle', 'Unlock_plan', 'Unlock_vehicle'].includes(this.checkList)) {
          //锁定  计划 委托车
          if (this.checkTableData.length > 1) return this.$message.warning('该操作只能选择一条');
          let map = new Map();
          this.tableId = '';
          switch (this.checkList) {
            case 'lock_plan': // 锁定计划
              //循环判断
              for (let [index, checkTableDatum] of this.checkTableData.entries()) {
                if (checkTableDatum.state === 3 && checkTableDatum.switch_state === 1) {
                  return this.$message.warning(`已交车和已锁定的计划不能锁定`);
                } else {
                  //去重，不能重复
                  map.set(checkTableDatum.planId, checkTableDatum);
                }
              }
              //清空重新赋值
              this.checkTableData = [...map.values()];
              for (let checkTableDatum of this.checkTableData) {
                this.tableId += checkTableDatum['planId'] + ',';
              }
              this.BatchModifyShow = true;
              //去掉 末尾逗号
              this.tableId = this.tableId.slice(0, this.tableId.length - 1);
              console.log(this.tableId);
              break;

            case 'Unlock_plan': //解锁计划
              //循环判断
              for (let [index, checkTableDatum] of this.checkTableData.entries()) {
                if (checkTableDatum.switch_state !== 1) {
                  return this.$message.warning(`只有已锁定状态才能解锁`);
                } else {
                  //去重，不能重复
                  map.set(checkTableDatum.planId, checkTableDatum);
                }
              }
              //清空重新赋值
              this.checkTableData = [...map.values()];
              for (let checkTableDatum of this.checkTableData) {
                this.tableId += checkTableDatum['planId'] + ',';
              }
              this.BatchModifyShow = true;
              //去掉 末尾逗号
              this.tableId = this.tableId.slice(0, this.tableId.length - 1);
              break;

            case 'lock_vehicle': //锁定委托车
              //循环判断
              for (let [index, checkTableDatum] of this.checkTableData.entries()) {
                if (checkTableDatum.state !== 0) {
                  return this.$message.warning(`该状态的委托车不能锁定`);
                } else if (checkTableDatum.switch_state == 1) {
                  return this.$message.warning(`该数据委托车已锁定`);
                } else {
                  //去重，不能重复
                  map.set(checkTableDatum.id, checkTableDatum);
                }
              }
              //清空重新赋值
              this.checkTableData = [...map.values()];
              for (let checkTableDatum of this.checkTableData) {
                this.tableId += checkTableDatum['id'] + ',';
              }
              this.BatchModifyShow = true;
              //去掉 末尾逗号
              this.tableId = this.tableId.slice(0, this.tableId.length - 1);
              console.log(this.tableId);
              break;

            case 'Unlock_vehicle': //解锁委托车
              //循环判断
              for (let [index, checkTableDatum] of this.checkTableData.entries()) {
                if (checkTableDatum.switch_state != 1) {
                  return this.$message.warning(`只有已锁定状态的委托车才能解锁`);
                } else {
                  //去重，不能重复
                  map.set(checkTableDatum.id, checkTableDatum);
                }
              }
              //清空重新赋值
              this.checkTableData = [...map.values()];
              for (let checkTableDatum of this.checkTableData) {
                this.tableId += checkTableDatum['id'] + ',';
              }
              this.BatchModifyShow = true;
              //去掉 末尾逗号
              this.tableId = this.tableId.slice(0, this.tableId.length - 1);
              break;
          }
          console.log('ddddd');
        } else {
          //修改计划，委托车
          switch (this.checkList) {
            case 'modify_plan':
              if (this.checkTableData.length > 1) return this.$message.warning('该操作只能选择一条');
              transportPlanCvDetail(this.checkTableData[0].planId)
                .then(res => {
                  for (let transportChildCvListElement of res.data.transportChildCvList) {
                    if (transportChildCvListElement.state !== 0) {
                      return this.$message.warning('该计划下的委托车，只有待分配才可修改');
                    } else if (transportChildCvListElement.isOutStorage === 1) {
                      return this.$message.warning('该计划下的委托车，已出库不可修改');
                    }
                  }
                  //数据回显
                  this.changeClick(this.checkTableData[0]);
                })
                .catch(() => {});
              break;
            case 'modify_vehicle':
              //保存第一个运输条款 作对比
              let trans_rules_type = this.checkTableData[0].transport_mode;
              for (let checkTableDatum of this.checkTableData) {
                if (checkTableDatum.state !== 0) {
                  return this.$message.warning('该委托车，只有待分配才可修改');
                } else if (checkTableDatum.is_out_storage === 1) {
                  return this.$message.warning('已出库的委托车不可修改');
                } else if (checkTableDatum.transport_mode !== trans_rules_type) {
                  return this.$message.warning('只能选择同一个运输条款的委托车');
                }
              }
              //根据线路类型请求线路数据
              publicSelectLine({ type: trans_rules_type })
                .then(res => {
                  if (res.status !== 0) return this.$message.error(res.message);
                  this.modifyVehicleLineOption = res.data.map(item => {
                    return {
                      line_name: item.line_name,
                      id: item.id,
                    };
                  });
                })
                .catch(() => {});
              //查询品牌型号
              this._brandData();
              this.modifyVehicle = true;

              this.modifyVehicleTable = this.checkTableData.map((item, index) => {
                return {
                  ...item,
                  batch_number: item.batch_number,
                  consignor_name: item.consignor_name,
                  supplier: item.waybill_no,
                  num: item.frame_number,
                  chooseLine: item.line_id,
                  // transport:item.transport_mode,
                  brand: [item.brand_id, item.model_id],
                  color: item.color,
                  remark: item.file_name,
                  id: item.id,
                };
              });

              break;
            case 'modify_line':
              //修改线路
              //保存第一个运输条款 作对比
              let transport_mode = this.checkTableData[0].transport_mode;
              for (let checkTableDatum of this.checkTableData) {
                if (checkTableDatum.state !== 0) {
                  return this.$message.warning('该委托车，只有待分配才可修改');
                } else if (checkTableDatum.is_out_storage === 1) {
                  return this.$message.warning('已出库的委托车不可修改');
                } else if (checkTableDatum.transport_mode !== transport_mode) {
                  return this.$message.warning('只能选择同一个运输条款的委托车');
                }
              }
              this.modifyVehicle = true;
              //根据线路类型请求线路数据
              publicSelectLine({ type: transport_mode })
                .then(res => {
                  if (res.status !== 0) return this.$message.error(res.message);
                  this.modifyVehicleLineOption = res.data.map(item => {
                    return {
                      line_name: item.line_name,
                      id: item.id,
                    };
                  });
                })
                .catch(() => {});

              //查询品牌型号
              this._brandData();
              this.modifyVehicleTable = this.checkTableData.map((item, index) => {
                return {
                  batch_number: item.batch_number,
                  consignor_name: item.consignor_name,
                  supplier: item.waybill_no,
                  num: item.frame_number,
                  chooseLine: item.line_id,
                  // transport:item.transport_mode,
                  brand: [item.brand_id, item.model_id],
                  color: item.color,
                  remark: item.file_name,
                  id: item.id,
                };
              });

              break;
            case 'arrive_place':
              if (this.checkTableData.length < 0) return this.$message.warning('请选择数据后修改目的地！');
              const carIdList = [];
              this.checkTableData.forEach(item => {
                carIdList.push(item.id);
              });
              this.$refs.arrivePlaceRef.dialogOpen(carIdList);
              break;
            case 'submit_modified_data_appy_for':
              // console.log('这里 --->');
              // console.log(this.checkTableData);
              let ids = '';
              this.checkTableData.forEach(element => {
                if (element['id']) ids = ids + element['id'] + ',';
              });
              ids = ids.substring(0, ids.lastIndexOf(','));
              const commitRes = await commit({ ids: ids });
              // console.log(commitRes);
              if (commitRes.status == 0) {
                this.$message({
                  message: commitRes.message,
                  type: 'success',
                });
              } else if (commitRes.status == -1) {
                this.$message.error(commitRes.message);
              } else {
                this.$message({
                  message: commitRes.message,
                  type: 'warning',
                });
              }
              break;
            case 'compulsory_delivery':
              const idsi = this.checkTableData.map(item => item.id).join(',');
              const res = await forceArrive({ ids: idsi });
              if (res.status !== 0) {
                this.$message.error(res.message);
              } else {
                this.$message.success(res.message);
                this.importLoading = true;
                this.searchBtn();
                setTimeout(() => {
                  this.visible = false;
                  this.checkList = '';
                  this.importLoading = false;
                }, 1000);
              }
              break;
          }
        }
      },
      // 修改委托车 —— 重置
      modifyVehicleReset() {
        // console.log(111);
        this.modifyVehicleForm = {
          terms: '', //运输条款
          month: '', // 运输方式
          point: '', //提车场点
          startPosition: '', //起运地
          endPosition: '', //目的地
          startPort: '', // 起运港
          endPort: '', // 目的港
          unit: '', // 收车单位
          planTime: '', //计划时间
          chooseLine: '',
        };
      },
      // 修改委托车 —— 操作 删除
      removeVehicle(index) {
        this.modifyVehicleTable.splice(index, 1);
      },
      //修改委托商弹窗关闭
      modifyVehicleDialogClose() {
        this.modifyVehicle = false;
        this.modifyVehicleTable = [];
        this.modifyVehicleForm = {
          terms: '', //运输条款
          month: '', // 运输方式
          point: '', //提车场点
          startPosition: '', //起运地
          endPosition: '', //目的地
          startPort: '', // 起运港
          endPort: '', // 目的港
          unit: '', // 收车单位
          planTime: '', //计划时间
          chooseLine: '',
        };
        Object.assign(this.$data.modifyVehicleForm, this.$options.data().modifyVehicleForm);
        this.$refs.modifyVehicleTable.clearSelection();
        this.modifyVehicleCheckTableData = [];
      },
      //修改委托车 确认
      modifyVehicleSaveClick() {
        if (this.modifyVehicleCheckTableData.length === 0) return this.$message.warning('请选择要修改的数据');
        //判断是 修改委托车 还是线路
        if (this.checkList === 'modify_vehicle') {
          //循环表格
          for (let modifyVehicleTableElement of this.modifyVehicleCheckTableData) {
            //循环批量修改的字段
            for (let modifyVehicleFormKey in this.modifyVehicleForm) {
              //如果批量修改字段不为空
              if (this.modifyVehicleForm[modifyVehicleFormKey]) {
                //循环表格对象 key值
                for (let modifyVehicleTableElementKey in modifyVehicleTableElement) {
                  //判断是否与批量修改字段是否相等
                  if (modifyVehicleFormKey === modifyVehicleTableElementKey) {
                    //相等就赋值
                    modifyVehicleTableElement[modifyVehicleTableElementKey] = this.modifyVehicleForm[modifyVehicleFormKey];
                  }
                }
              }
            }
          }
        } else {
          //循环表格
          for (let modifyVehicleTableElement of this.modifyVehicleCheckTableData) {
            modifyVehicleTableElement.chooseLine = this.modifyVehicleForm.chooseLine;
          }
        }
      },
      //修改委托车 保存
      async modifyVehicleSave() {
        const arr = this.modifyVehicleCheckTableData.map(item => {
          return {
            id: item.id,
            waybillNo: item.supplier,
            frameNumber: item.num,
            modelId: item.brand[1],
            lineId: item.chooseLine,
            transportMode: item.transport,
            color: item.color,
            fileName: item.remark,
          };
        });
        // 判断是修改委托车 还是线路
        let res = this.checkList === 'modify_vehicle' ? await transportPlanCvModifyBatchEntrustCar(arr) : await transportPlanCvModifyBatchLineInfo(arr);
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.$refs.selectTable.clearSelection();
        //分页更新
        await this._transportPlanCvPageList();
        this.modifyVehicleDialogClose();
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      //表格多选
      handleCurrentChange(val) {
        this.checkTableData = val;
      },
      //修改委托车
      modifyVehicleHandleCurrentChange(value) {
        this.modifyVehicleCheckTableData = value;
      },
      // 批量操作 —— 确认
      async confirmBatchModify() {
        this.tipSureLoading = true;
        let res = {};
        //删除接口
        switch (this.checkList) {
          case 'batch_number': //批次号
            res = await transportPlanCvDeleteBatchNumber(this.tableId);
            break;
          case 'waybill_no': //运单号
            res = await transportPlanCvDeleteBatchWaybillNumber(this.tableId);
            break;
          case 'frame_number': //车架号
            res = await transportPlanCvDeleteBatchFrameNumber(this.tableId);
            break;
          case 'lock_plan': //锁定计划
            res = await transportPlanCvLockBatchPlan(this.tableId);
            break;
          case 'lock_vehicle': //锁定委托车
            res = await transportPlanCvLockBatchEntrustCar(this.tableId);
            break;
          case 'Unlock_plan': //解锁计划
            res = await transportPlanCvUnlockBatchPlan(this.tableId);
            break;
          case 'Unlock_vehicle': //解锁委托车
            res = await transportPlanCvUnlockBatchEntrustCar(this.tableId);
            break;
        }
        if (res.status !== 0) {
          this.$message.error(res.message);
          this.tipSureLoading = false;
          return;
        }
        this.$message.success(res.message);
        this.BatchModifyShow = false;
        //分页
        await this._entrustedCarPageList();
        this.$refs.selectTable.clearSelection();
        this.tipSureLoading = false;
      },
      //弹窗关闭
      BatchModifyClose() {
        this.checkList = '';
        this.BatchModifyShow = false;
        this.visible = false;
        // this.checkTableData = []
        // this.$refs.selectTable.clearSelection()
      },
      searchCopyFormat(value, flag) {
        console.log(value);
        // value.clipboardData.getData('Text').split('\n')
        let splitArr = value.clipboardData.getData('Text').replace(/\s/g, ',').split(',');
        splitArr = splitArr.filter(item => item);
        console.log(splitArr);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        switch (flag) {
          case 'batchIpt':
            this.entrust.batchIpt = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
          case 'waybill_no':
            this.entrust.waybill_no = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
          case 'frame_number':
            this.entrust.frame_number = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
        }
      },

      // 运输条款
      transRulesType(row) {
        let type1 = '',
          type2 = '',
          text = '';
        if (row.transRulesType) {
          type1 = row.transRulesType.toString().split('-')[0];
          type2 = row.transRulesType.toString().split('-')[1];
        }
        switch (type1) {
          case 'VDC':
            type1 = '主机厂库房';
            break;
          case 'GK':
            type1 = '港口';
            break;
        }
        switch (type2) {
          case 'GK':
            type2 = '港口';
            break;
          case 'VSC':
            type2 = '到中专库、区域';
            break;
          case 'DO':
            type2 = '到经销商门店';
            break;
        }
        if (type1 != '' && type2 != '') text = type1 + '-' + type2;
        return text;
      },
      // 运输方式
      transportMode(row) {
        switch (row.transportMode) {
          case 1:
            return '公路';
          case 2:
            return '水路';
          case 3:
            return '水陆联运';
        }
      },

      // 运输条款改变
      shipTypeChange(val, type) {
        this.typeOption = [];
        if (type == 1) {
          this.teamData.transportType2 = '';
        }
        if (this.addTable.length > 0) {
          this.addTable.forEach(item => {
            item.startAreaType = true;
            item.endAreaType = true;
            item.startPortType = true;
            item.endPortType = true;
            item.transport = '';
            item.startArea = '';
            item.endArea = '';
            item.startPort = '';
            item.endPort = '';
          });
        }
        this.$forceUpdate();
      },
      // 验证运输条款
      verifyType() {
        this.typeOption = [];
        let type1 = this.teamData.transportType1;
        let type2 = this.teamData.transportType2;
        if (!type1 || type1 == '' || !type2 || type2 == '') {
          return this.$message.warning('请先选择运输条款！');
        }
        if (type1 == 'GK' && type2 == 'GK') {
          this.typeOption = [
            {
              id: 1,
              name: '公路',
            },
            {
              id: 2,
              name: '水路',
            },
          ];
        } else if (type2 == 'GK') {
          this.typeOption = [
            {
              id: 1,
              name: '公路',
            },
            {
              id: 2,
              name: '水路',
            },
            {
              id: 3,
              name: '水陆联运',
            },
          ];
        } else {
          this.typeOption = [
            {
              id: 1,
              name: '公路',
            },
            {
              id: 3,
              name: '水陆联运',
            },
          ];
        }
      },
      // 运输方式改变
      transportChange(val) {
        let type = this.teamData.transportType1 + '-' + this.teamData.transportType2;
        if (val.id == 1) {
          if (type == 'GK-GK') {
            // this.addTable.forEach(item => {
            this.tranType.startAreaType = true;
            this.tranType.endAreaType = true;
            this.tranType.startPortType = false;
            this.tranType.endPortType = false;
            // })
          }
          if (type == 'GK-VSC' || type == 'GK-DO') {
            // this.addTable.forEach(item => {
            this.tranType.startAreaType = true;
            this.tranType.endAreaType = false;
            this.tranType.startPortType = false;
            this.tranType.endPortType = true;
            // })
          }
          if (type == 'VDC-GK') {
            // this.addTable.forEach(item => {
            this.tranType.startAreaType = false;
            this.tranType.endAreaType = true;
            this.tranType.startPortType = true;
            this.tranType.endPortType = false;
            // })
          }
          if (type == 'VDC-VSC' || type == 'VDC-DO') {
            // this.addTable.forEach(item => {
            this.tranType.startAreaType = false;
            this.tranType.endAreaType = false;
            this.tranType.startPortType = true;
            this.tranType.endPortType = true;
            // })
          }
        } else if (val.id == 2) {
          if (type == 'GK-GK') {
            // this.addTable.forEach(item => {
            this.tranType.startAreaType = true;
            this.tranType.endAreaType = true;
            this.tranType.startPortType = false;
            this.tranType.endPortType = false;
            // })
          } else {
            // this.addTable.forEach(item => {
            this.tranType.startAreaType = true;
            this.tranType.endAreaType = true;
            this.tranType.startPortType = false;
            this.tranType.endPortType = false;
            // })
          }
        } else {
          if (type == 'GK-VSC' || type == 'GK-DO') {
            // this.addTable.forEach(item => {
            this.tranType.startAreaType = true;
            this.tranType.endAreaType = false;
            this.tranType.startPortType = false;
            this.tranType.endPortType = false;
            // })
          }
          if (type == 'VDC-GK' || type == 'VDC-VSC' || type == 'VDC-DO') {
            // this.addTable.forEach(item => {
            this.tranType.startAreaType = false;
            this.tranType.endAreaType = false;
            this.tranType.startPortType = false;
            this.tranType.endPortType = false;
            // })
          }
        }
        this.$forceUpdate();
      },
      // 港口选择
      portChange(val, index, type) {
        if (this.addTable[index].startPort == this.addTable[index].endPort) {
          if (type == 'start') {
            this.addTable[index].startPort = '';
          }
          if (type == 'end') {
            this.addTable[index].endPort = '';
          }
          return this.$message.warning('起始港口与交车港口不能相同！');
        }
      },

      // 起运地
      startPlace(row) {
        if (row.departure_place_type == 2) {
          return '';
        } else {
          return row.departure_place;
        }
      },
      // 目的地
      endPlace(row) {
        if (row.arrive_place_type == 2) {
          return '';
        } else {
          return row.arrive_place;
        }
      },
      getDefaultDate() {
        let timeC = new Date().setMonth(new Date().getMonth() - 3);
        let year = new Date(parseInt(timeC)).getFullYear();
        let month = new Date(parseInt(timeC)).getMonth() + 1;
        let date = new Date(parseInt(timeC)).getDate();
        if (month < 10) {
          month = '0' + month;
        }
        if (date < 10) {
          date = '0' + date;
        }
        this.startDate = this.entrust.startTimeIpt = year + '-' + month + '-' + date;
        this.endDate = this.entrust.endTimeIpt = new Date().getFullYear() + '-' + (new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1 < 10) + '-' + (new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate());
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;

    // height: auto !important;
    .tabs {
      float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 240px;
      margin-bottom: 10px;

      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599e;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599e;
        font-weight: 700;
        transition: all 0.3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      .right {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }

      .active {
        background: #48599e;
        color: #fff;
      }
    }

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      .navContainer {
        p {
          display: inline-block;
          width: 70px;
          text-align: right;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      max-height: calc(100% - 200px);

      .tableContainer {
        margin-top: 10px;
        margin-bottom: 15px;
        width: 100%;

        ::v-deep .el-table__header .has-gutter tr .el-table-column--selection .cell .el-checkbox::after {
          color: #606266;
          content: '全选';
          font-size: 12px;
          margin-left: 2px;
        }

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .inpt {
      ::v-deep {
        .el-input__inner {
          border: 1px solid #dcdfe6 !important;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      // max-height:75vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 40%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td,
          .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    .company {
      width: 100%;
      padding: 20px 20px 10px;

      .productTable1 {
        margin-top: 15px;
        margin-right: 10px;

        ::v-deep {
          .el-table td .cell span {
            display: inline-block;
            width: 25px;
            height: 25px;
            line-height: 25px;
            font-size: 25px;
            margin: 0 3px;
            vertical-align: top;

            &.del-style {
              color: #555656;
            }

            &.edit-style {
              background: #ff9933;
              color: #fff;
              border-radius: 50%;
              font-size: 16px;
              width: 22px;
              height: 22px;
              line-height: 22px;
              margin-top: 1px;
            }
          }

          .el-input--mini .el-input__inner {
            width: 100%;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }

          .el-table td,
          .el-table th {
            padding: 0;
          }
        }

        .tableAddBtnContainer {
          border: 1px solid #ebeef5;
          border-top-style: none;
          width: 100%;
          height: 35px;
          display: flex;
          align-items: center;
          padding-left: 15px;

          .AddContainer {
            display: flex;
            align-items: center;

            &:hover {
              cursor: pointer;
            }
          }

          img {
            object-fit: cover;
            margin-right: 5px;
          }

          p {
            font-size: 13px;
            color: #f59a23;
            font-family: 'Arial Normal', 'Arial', sans-serif;
          }
        }
      }

      .productTable {
        margin-top: 15px;
        margin-right: 10px;

        ::v-deep {
          .el-input--mini .el-input__inner {
            width: 100%;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }

          .el-table td,
          .el-table th {
            padding: 0;
          }
        }

        .tableAddBtnContainer {
          border: 1px solid #ebeef5;
          border-top-style: none;
          width: 100%;
          height: 35px;
          display: flex;
          align-items: center;
          padding-left: 15px;

          .AddContainer {
            display: flex;
            align-items: center;

            &:hover {
              cursor: pointer;
            }
          }

          img {
            object-fit: cover;
            margin-right: 5px;
          }

          p {
            font-size: 13px;
            color: #f59a23;
            font-family: 'Arial Normal', 'Arial', sans-serif;
          }
        }
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-input__inner {
          // border: none;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item {
          margin-bottom: 15px;
        }

        .el-form-item__content {
          position: relative;
          margin-bottom: 10px;
        }
      }

      hr {
        margin: 0;
        position: absolute;
        width: 100%;
        bottom: 5px;
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0 5px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }

      .el-radio__label {
        padding-left: 5px;
      }

      .el-radio {
        margin-right: 10px;
      }
    }

    ::v-deep.update {
      font-size: 14px;
      color: rgba(51, 136, 255, 1);

      /*text-decoration: underline;*/
      & > a:visited {
        color: rgba(51, 136, 255, 1);
        /* 访问过的链接样式 */
      }
    }
  }

  ::v-deep {
    .el-table th.require > div::before {
      content: '*';
      color: red;
    }

    span.el-icon-download {
      font-size: 16px;
      text-decoration: underline;
    }

    span i.el-icon-upload.el-icon--right {
      font-size: 16px;
      text-decoration: underline;
    }

    .company[data-v-5d3fda04] .el-form-item {
      margin-bottom: 0px !important;
    }

    .company[data-v-5d3fda04] .el-form-item__label {
      font-weight: 400 !important;
      color: #000;
    }

    td {
      height: 40px !important;
    }

    .el-table .ui-warning-row {
      background: #ddd !important;
    }

    .el-table .ui-warning-row .cell {
      color: red;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 16px;
      font-weight: 700;
      color: #ffffff;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }

    .el-dialog__body {
      max-height: 70vh;
      overflow-y: auto;
      overflow-x: hidden;
    }

    .elradio {
      span:hover {
        color: #002fc1;
      }

      .el-radio {
        margin-bottom: 10px !important;
      }
    }

    .cell input.table-input {
      -webkit-appearance: none;
      background-color: #fff;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      height: 28px;
      line-height: 28px;
      outline: 0;
      padding: 0 15px;
      -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100%;
    }

    .cell {
      input::-webkit-input-placeholder {
        color: #c0c4cc;
      }

      input:-moz-placeholder {
        /* Firefox 19+ */
        color: #c0c4cc;
      }

      input::-moz-placeholder {
        /* IE 10+ */
        color: #c0c4cc;
      }

      input:-ms-input-placeholder {
        /* Firefox 18- */
        color: #c0c4cc;
      }
    }
  }

  ::v-deep.BatchModifyC {
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #fdfdfd !important;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #050505 !important;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #000000 !important;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }

    .el-dialog__body {
      max-height: 600px;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }

  * {
    touch-action: pan-y;
  }
</style>
